import React, { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import stilePulsanti from "./../../interfaccia/stilePulsanti";
import InputDatoProdotto from "../../modificaProdotti/elementiPagina/InputDatoProdotto";
import _ from "lodash";
import Articolo from "./OrdineComponenti/Articolo";
import Reso from "./OrdineComponenti/Reso";
import umanizzaDataSenzaOre from "../../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import apiUrl from "../../Apiurl";
import InputDatoTendinaGenerico from "../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import InputTendinaDatoProdotto from "../../modificaProdotti/elementiPagina/InputTendinaDatoProdotto";
import Nota from "./OrdineComponenti/Nota";
import mouseIMG from "../../files/img/mouse.webp";
import TastoSelezionaTab from "./OrdineComponenti/TastoSelezionaTab";
import associaImmagineENomeANomeUtente from "../../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";
import Timeline from "./OrdineComponenti/Timeline";
import StatiPrestashop from "./OrdineComponenti/StatiPrestashop";
import Fatture from "./OrdineComponenti/Fatture";
import RiquadrinoOrdine from "./OrdineComponenti/RiquadrinoOrdine";
import {
  calcolaIndiceGlobaleOrdine,
  creaParametriNavigazioneOrdini,
  estraiIdOrdiniAdiacenti,
} from "./funzioniNavigazioneOrdini";
import {
  calcolaComposizioneRimborso,
  preparaConfigurazionePerPersistenza,
} from "./OrdineComponenti/rimborsoUtils";

function leggiNumero(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function arrotondaImporto(value) {
  return Math.round((leggiNumero(value) + Number.EPSILON) * 100) / 100;
}

function isMenuOrdineBloccatoUtente(utente) {
  return Number(utente?.logisticaMenuOrdineBloccato || 0) === 1;
}

function ModificaOrdini({
  ordine,
  setOrdineFunction,
  utente,
  datiTendineOrdine: cataloghiOrdine,
  popUp,
  listaId,
  indexOrdine,
  setIndexOrdine,
  page,
  perPage,
  ricerca,
  columnSort,
  directionSort,
  urlRicerca,
  vista,
}) {
  const datiTendineOrdine = { ...cataloghiOrdine };

  const {
    buttonClassesWhite,
    buttonClassesRed,
    buttonClassesGreen,
    buttonClassesAttesa,
    classiTastoSblocco,
    vociMenuTabs,
    vociMenuTabsSelezionata,
    inputClassesNOW,
    riquadroClassesRed,
    tastoSXAspetto,
    tastoDXAspetto,
    tastoSalvaAspetto,
    tastoSalvaChiudiAspetto,
    tastoChiudiAspetto,
  } = stilePulsanti;

  let classDivPrincipale =
    "fixed-l w-100-l sfondoColAlt h-100 colonnaTuttaPagina-ns";

  if (popUp) {
    classDivPrincipale = "br4-ns sfondoBiancoTema flex flex-wrap h-100";
  }

  ///// HOOKS //////////////////

  const [ordineTemp, setOrdineTemp] = useState(ordine);
  const [salvato, setSalvato] = useState(true);
  const [tab, setTab] = useState("default");
  const [menuOrdineEspanso, setMenuOrdineEspanso] = useState(false);
  const [menuOrdineBloccato, setMenuOrdineBloccato] = useState(
    isMenuOrdineBloccatoUtente(utente),
  );
  const [menuOrdineInHover, setMenuOrdineInHover] = useState(false);
  const menuOrdinePinRef = useRef(null);
  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [alert, setAlert] = useState("");
  const [datiStati, setDatiStati] = useState([]);
  const [resultSalvataggio, setResultSalvataggio] = useState(false);
  const [alertSalvataggio, setAlertSalvataggio] = useState(false);
  const [arrArticoliSottoControllo, setArrArticoliSottoControllo] = useState(
    ordineTemp.articoliArr,
  );
  const [arrNoteSottoControllo, setArrNoteSottoControllo] = useState(
    ordineTemp.noteArr,
  );
  const [bloccoMagazzinoPartenza, setBloccoMagazzinoPartenza] = useState(false);
  const [tabSpedizioniCollegate, setTabSpedizioniCollegate] =
    useState("correlate");
  const [spedizioniCorrelate, setSpedizioniCorrelate] = useState([]);
  const [garanzieCorrelate, setGaranzieCorrelate] = useState([]);
  const [ordiniCliente, setOrdiniCliente] = useState([]);
  const [loadingSpedCorrelate, setLoadingSpedCorrelate] = useState(false);
  const [idOrdinePrecedente, setIdOrdinePrecedente] = useState(null);
  const [idOrdineSuccessivo, setIdOrdineSuccessivo] = useState(null);
  const [navigazioneInCorso, setNavigazioneInCorso] = useState(false);
  const navigationRequestRef = useRef(null);
  const usaNavigazionePaginata = Boolean(
    urlRicerca?.includes("/ricercaOrdiniDBavanzataPagination/"),
  );
  const spedizioneBase = ordine?.spedEclifor?.[0];
  const idSpedizioneCorrente = spedizioneBase?.["ID Spedizione"];
  const hasGaranzieCorrelate =
    garanzieCorrelate && garanzieCorrelate.length > 0;
  const statoGaranziaBanner = hasGaranzieCorrelate
    ? garanzieCorrelate?.[0]?.statoGaranzia || "N/D"
    : "";
  const bannerGaranziaClass =
    statoGaranziaBanner === "RIFIUTATA" || statoGaranziaBanner === "ACCETTATA"
      ? buttonClassesGreen
      : "colAttesa white";
  const canUpdateLogistica = Boolean(utente?.permessiAPI?.["update:logistica"]);
  const canReadLogistica = Boolean(utente?.permessiAPI?.["read:logistica"]);
  const canScrivereNote =
    canUpdateLogistica || Boolean(utente?.permessiAPI?.["print:logistica"]);
  const spedizioneNuova =
    ordineTemp?.spedEclifor?.[0]?.["ID Spedizione"] === "NUOVO";
  const noteDaSalvare = Boolean(
    ordineTemp?.noteArr?.some((nota) => nota.daSalvare),
  );
  const preferenzaMenuOrdineBloccato = utente?.logisticaMenuOrdineBloccato;
  const statoOrdineCorrente =
    ordineTemp?.spedEclifor?.[0]?.["Stato_Ordine"] || "";
  const mostraAtteseInHome = Boolean(
    statoOrdineCorrente.includes("ATTESA") ||
    ordineTemp?.spedEclifor?.[0]?.["userAttesa"] ||
    ordineTemp?.spedEclifor?.[0]?.["dataPromemoria"] ||
    ordineTemp?.spedEclifor?.[0]?.["ricordamelo"] === 1,
  );
  const salvaPreferenzaMenuOrdine = async (bloccato) => {
    if (!token) {
      return;
    }

    try {
      await axios.patch(
        `${apiUrl}/auth/preferenze/logistica-menu-ordine`,
        { bloccato, emailAuth: utente.email },
        { headers: { Authorization: "Bearer " + token } },
      );
    } catch (error) {
      console.warn("Errore salvataggio preferenza menu ordine", error);
    }
  };

  const bloccaMenuOrdine = () => {
    const nuovoValore = !menuOrdineBloccato;
    if (nuovoValore) {
      setMenuOrdineEspanso(menuOrdineEspanso || menuOrdineInHover);
    }
    setMenuOrdineBloccato(nuovoValore);
    salvaPreferenzaMenuOrdine(nuovoValore);
  };

  const handleMenuOrdineMouseMove = (e) => {
    const pinRect = menuOrdinePinRef.current?.getBoundingClientRect();
    const mouseNellaFasciaPin =
      pinRect &&
      e.clientY >= pinRect.top - 25 &&
      e.clientY <= pinRect.bottom + 25;

    setMenuOrdineInHover(!menuOrdineBloccato && !mouseNellaFasciaPin);
  };

  const impostaOrdineCollegato = (e, idSped) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    if (!idSped || !token) {
      return;
    }
    fetch(apiUrl + "/logistica/ricerca/ricOrdineCodSpedQuerySep/" + idSped, {
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => setOrdineFunction(data || "NO DATA"));
  };

  const apriSpedizioneDaId = async (idSped) => {
    if (!idSped || !token) {
      throw new Error("ID spedizione o token non disponibile");
    }

    const response = await axios.get(
      `${apiUrl}/logistica/ricerca/ricOrdineCodSpedQuerySep/${idSped}`,
      { headers: { Authorization: "Bearer " + token } },
    );
    if (!response.data?.spedEclifor?.[0]?.["ID Spedizione"]) {
      throw new Error(`Spedizione ${idSped} creata ma non ricaricabile`);
    }
    setOrdineFunction(response.data);
  };

  useEffect(() => {
    switch (ordineTemp.spedEclifor[0]["Stato_Ordine"]) {
      case "RICERCA":
      case "PRONTO EXP":
      case "ETICHETTE":
      case "SPEDITO":
        setBloccoMagazzinoPartenza(true);
        break;
      default:
        setBloccoMagazzinoPartenza(false);
        break;
    }
  }, [ordineTemp.spedEclifor[0]["Stato_Ordine"]]);

  datiTendineOrdine.dhlCodPaese = datiStati.map((stato) => {
    return {
      idPS: stato["iso_code"],
      desc: stato["namePS"] + " - " + stato["iso_code"],
    };
  });

  datiTendineOrdine.nomiNazioni = datiStati.map((stato) => {
    return { idPS: stato["namePS"], desc: stato["namePS"] };
  });

  datiTendineOrdine.codiceNazioni = datiStati.map((stato) => {
    return {
      idPS: stato["codPaeseAccess"],
      desc: stato["namePS"] + " - " + stato["codPaeseAccess"],
    };
  });

  datiTendineOrdine.prefissoNazione = datiStati.map((stato) => {
    return {
      idPS: stato["call_prefix"],
      desc: stato["namePS"] + " - " + stato["call_prefix"],
    };
  });

  ///// FUNZIONI ///////////////

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    setMenuOrdineBloccato(
      Number(preferenzaMenuOrdineBloccato || 0) === 1,
    );
  }, [preferenzaMenuOrdineBloccato]);

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    fetch(apiUrl + "/logistica/ordine/getTabStati", {
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => setDatiStati(data));
  }, [token]);

  useEffect(() => {
    const idPS = spedizioneBase?.["N_rif_PrestaShop"];
    const idMP = spedizioneBase?.["N_rif_MarketPlace"];
    const fonte = spedizioneBase?.fonte || "VIG";
    const idSped = idSpedizioneCorrente;
    const nomeCliente = spedizioneBase?.NomeCognome;
    if (!token || (!idPS && !idMP && !nomeCliente && !idSped)) {
      return;
    }
    const fetchData = async () => {
      setLoadingSpedCorrelate(true);
      try {
        const headers = { Authorization: "Bearer " + token };
        const params = {
          idPS,
          idMP,
          fonte,
          nomeCliente,
          idSped,
          includeArticoli: 1,
          includeGaranzie: 1,
          limit: 50,
        };
        const response = await axios.get(
          apiUrl + "/logistica/ricerca/ricercaOrdiniCorrelati",
          { params, headers },
        );
        const ordiniCorrelati = Array.isArray(response.data?.ordiniCorrelati)
          ? response.data.ordiniCorrelati
          : [];
        const ordiniCliente = Array.isArray(response.data?.ordiniCliente)
          ? response.data.ordiniCliente
          : [];
        const garanzie = Array.isArray(response.data?.garanzie)
          ? response.data.garanzie
          : [];

        setSpedizioniCorrelate(
          ordiniCorrelati.filter(
            (row) => row["ID Spedizione"] !== idSped && row.id !== idSped,
          ),
        );
        setOrdiniCliente(
          ordiniCliente.filter(
            (row) => row["ID Spedizione"] !== idSped && row.id !== idSped,
          ),
        );
        setGaranzieCorrelate(garanzie);
        setTabSpedizioniCollegate(
          garanzie.length > 0 ? "garanzie" : "correlate",
        );
      } catch (err) {
        console.error("Errore caricamento spedizioni correlate", err);
      } finally {
        setLoadingSpedCorrelate(false);
      }
    };
    fetchData();
  }, [idSpedizioneCorrente, spedizioneBase, token]);

  useEffect(() => {
    if (!setIndexOrdine) {
      return;
    }
    if (usaNavigazionePaginata) {
      const indiceGlobale = calcolaIndiceGlobaleOrdine({
        listaId,
        idSpedizione: idSpedizioneCorrente,
        page,
        perPage,
      });
      if (indiceGlobale !== null) {
        setIndexOrdine(indiceGlobale);
      }
      return;
    }
    setIndexOrdine(listaId?.indexOf(idSpedizioneCorrente));
  }, [
    idSpedizioneCorrente,
    listaId,
    page,
    perPage,
    setIndexOrdine,
    usaNavigazionePaginata,
  ]);

  useEffect(() => {
    setArrArticoliSottoControllo(ordineTemp.articoliArr);
    setArrNoteSottoControllo(ordineTemp.noteArr);
  }, [ordineTemp]);

  useEffect(() => {
    if (
      !usaNavigazionePaginata ||
      !token ||
      !Number.isInteger(indexOrdine) ||
      navigazioneInCorso
    ) {
      return undefined;
    }

    if (!idSpedizioneCorrente) {
      return undefined;
    }

    setIdOrdinePrecedente(null);
    setIdOrdineSuccessivo(null);
    navigationRequestRef.current?.abort();
    const controller = new AbortController();
    navigationRequestRef.current = controller;
    const params = creaParametriNavigazioneOrdini({
      ricerca,
      columnSort,
      directionSort,
      navigationIndex: indexOrdine,
      vista,
    });

    axios
      .get(`${urlRicerca}1/1?${params.toString()}`, {
        headers: { Authorization: "Bearer " + token },
        signal: controller.signal,
      })
      .then((response) => {
        if (controller.signal.aborted) {
          return;
        }
        const adiacenti = estraiIdOrdiniAdiacenti(
          response.data?.listaIdSped,
          idSpedizioneCorrente,
        );
        setIdOrdinePrecedente(adiacenti.idPrecedente);
        setIdOrdineSuccessivo(adiacenti.idSuccessivo);
      })
      .catch((error) => {
        if (!axios.isCancel(error) && !controller.signal.aborted) {
          console.error("Errore caricamento navigazione ordini", error);
          setIdOrdinePrecedente(null);
          setIdOrdineSuccessivo(null);
        }
      });

    return () => {
      controller.abort();
      if (navigationRequestRef.current === controller) {
        navigationRequestRef.current = null;
      }
    };
  }, [
    columnSort,
    directionSort,
    idSpedizioneCorrente,
    indexOrdine,
    navigazioneInCorso,
    ricerca,
    token,
    urlRicerca,
    usaNavigazionePaginata,
    vista,
  ]);

  useEffect(() => {
    setOrdineTemp(ordine);
  }, [ordine]);

  const handleChange = async function (evt) {
    setSalvato(false);
    const value = evt.target.value;
    try {
      if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
        const update = _.set(_.cloneDeep(ordineTemp), evt.target.name, value); // METODO RESOURCE EXPENSIVE
        const totaleResoMatch = evt.target.name.match(
          /resiErimborsiArr\[(\d+)\]\["resiTotale_rimborso"\]/,
        );
        if (totaleResoMatch) {
          _.set(
            update,
            "resiErimborsiArr[" +
              totaleResoMatch[1] +
              ']["resiConfigurazione_rimborso"]',
            null,
          );
        }
        setOrdineTemp(update);
      } else if (
        !evt.target.name.includes(".") &&
        !evt.target.name.includes("[")
      ) {
        setOrdineTemp({
          ...ordineTemp,
          [evt.target.name]: value,
        });
      } else {
        setAlert("Errore cambio dato");
      }
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
  };

  const handleChangeStato = async function (evt) {
    setSalvato(false);
    const value = evt.target.value;
    let update;
    try {
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, 'spedEclifor[0]["Stato_Ordine"]', value);
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    try {
      const clone = _.cloneDeep(update);
      _.set(clone, 'spedEclifor[0]["statoDaAggiornareSuPS"]', 1);
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  };

  const handleChangeImportoReso = async function (evt) {
    console.log(evt);
    setSalvato(false);
    const matchIndiceReso = evt.target.name.match(/resiErimborsiArr\[(\d+)\]/);
    const indiceReso = matchIndiceReso ? parseInt(matchIndiceReso[1], 10) : 0;
    let update;
    try {
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, evt.target.name, evt.target.value);
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    const resoCorrente = update.resiErimborsiArr?.[indiceReso] || {};
    const impArt = leggiNumero(resoCorrente["resiValore_merce"]);
    const impSpedA = leggiNumero(resoCorrente["resiSpedizione_A"]);
    const impSpedR = leggiNumero(resoCorrente["resiSpedizione_R"]);
    const valueTot = arrotondaImporto(impArt + impSpedA + impSpedR);
    try {
      const clone = _.cloneDeep(update);
      _.set(
        clone,
        "resiErimborsiArr[" + indiceReso + ']["resiConfigurazione_rimborso"]',
        null,
      );
      _.set(
        clone,
        "resiErimborsiArr[" + indiceReso + ']["resiTotale_rimborso"]',
        valueTot,
      );
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  };

  const handleChangeImportoArticolo = async function (evt, i) {
    const value = evt.target.value;
    if (evt.target.name.endsWith('["Quantità"]') &&
        (!Number.isFinite(Number(value)) || Number(value) < 1)) {
      return;
    }
    setSalvato(false);
    let update;
    try {
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, evt.target.name, value);
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    console.log(
      'update.articoliArr[i]["Importo unitario"]',
      update.articoliArr[i]["Importo unitario"],
    );
    console.log(
      'update.articoliArr[i]["Quantità"]',
      update.articoliArr[i]["Quantità"],
    );
    let impArt = update.articoliArr[i]["Importo unitario"]
      ? parseFloat(update.articoliArr[i]["Importo unitario"])
      : 0;
    let quant = update.articoliArr[i]["Quantità"]
      ? parseInt(update.articoliArr[i]["Quantità"])
      : 0;
    const valueTot = impArt * quant;
    try {
      const clone = _.cloneDeep(update);
      _.set(clone, "articoliArr[" + i + ']["Totale riga"]', valueTot);
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  };

  const rimborsoPresente = ordineTemp.resiErimborsiArr?.some((reso) =>
    reso && typeof reso === "object" && !Array.isArray(reso) && Number(reso["Quantità"]) !== 0
  );

  function rimborsaArticolo(i, quantitaRimborsata) {
    if (!canUpdateLogistica || !rimborsoPresente) return false;
    const articolo = ordineTemp.articoliArr[i];
    const quantita = Number(articolo["Quantità"]);
    if (!Number.isInteger(quantitaRimborsata) || quantitaRimborsata < 1 || quantitaRimborsata > quantita) return false;
    const residua = quantita - quantitaRimborsata;
    const update = _.cloneDeep(ordineTemp);
    update.articoliArr[i] = {
      ...articolo,
      "Quantità": residua,
      "Totale riga": arrotondaImporto(leggiNumero(articolo["Importo unitario"]) * residua),
      rimborso_articolo: true,
      mag_unita_rimosse: residua === 0
        ? (articolo.mag_unita || []).map((unita) => unita.id)
        : (articolo.mag_unita_rimosse || []),
    };
    setOrdineTemp(update);
    setSalvato(false);
    setAlertSalvataggio(false);
    return true;
  }

  const apriOrdineAdiacente = async (idSpedizione, nuovoIndice) => {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!idSpedizione) {
      return;
    }
    setNavigazioneInCorso(true);
    try {
      const response = await axios.get(
        apiUrl + "/logistica/ricerca/ricOrdineCodSpedQuerySep/" + idSpedizione,
        { headers: { Authorization: "Bearer " + token } },
      );
      if (setIndexOrdine && Number.isInteger(nuovoIndice)) {
        setIndexOrdine(nuovoIndice);
      }
      setOrdineFunction(response.data || "NO DATA");
    } catch (error) {
      console.error("Errore navigazione ordine", error);
      setAlert("Impossibile caricare l'ordine richiesto");
    } finally {
      setNavigazioneInCorso(false);
    }
  };

  const precedente = () => {
    const idPrecedente = usaNavigazionePaginata
      ? idOrdinePrecedente
      : listaId?.[indexOrdine - 1];
    apriOrdineAdiacente(idPrecedente, indexOrdine - 1);
  };

  const successivo = () => {
    const idSuccessivo = usaNavigazionePaginata
      ? idOrdineSuccessivo
      : listaId?.[indexOrdine + 1];
    apriOrdineAdiacente(idSuccessivo, indexOrdine + 1);
  };

  const magAssenteMandaTO = async function () {
    setSalvato(false);
    let update;
    try {
      // NON SO SE SERVE CLONARE OGNI VOLTA MA HO FRETTA E FACCIO COSI'
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, 'spedEclifor[0]["Stato_Ordine"]', "IN ATTESA");
      _.set(clone, 'spedEclifor[0]["Causale_Stato"]', "Magazzino assente");
      _.set(clone, 'spedEclifor[0]["Partenza_da"]', "Torino");
      _.set(clone, 'spedEclifor[0]["Data_partenza"]', "");
      console.log(clone);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  };

  const applicaComposizioneRimborso = async function (i, configurazione) {
    setSalvato(false);
    const importoSpedizione = leggiNumero(
      ordineTemp?.spedEclifor?.[0]?.Spese_di_spedizione,
    );
    const importoContrassegno = leggiNumero(
      ordineTemp?.spedEclifor?.[0]?.Spese_di_contrassegno,
    );
    const {
      importoMerce,
      importoSpedizioneAndata,
      importoSpedizioneRitorno,
      totaleRimborso,
    } = calcolaComposizioneRimborso(
      configurazione,
      importoSpedizione,
      importoContrassegno,
    );
    const resoCorrente = ordineTemp.resiErimborsiArr?.[i] || {};
    const dataOperazione = resoCorrente.resiData_operazione || new Date();
    const mezzoRimborso =
      resoCorrente.resiMezzo_rimborso ||
      ordineTemp?.spedEclifor?.[0]?.Tipo_di_pagamento ||
      "";
    try {
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, "resiErimborsiArr[" + i + "]", {
        ...resoCorrente,
        resiData_operazione: dataOperazione,
        resiMezzo_rimborso: mezzoRimborso,
        resiValore_merce: importoMerce,
        resiSpedizione_A: importoSpedizioneAndata,
        resiSpedizione_R: importoSpedizioneRitorno,
        resiTotale_rimborso: totaleRimborso,
        resiConfigurazione_rimborso: preparaConfigurazionePerPersistenza(
          configurazione,
          ordineTemp.articoliArr,
        ),
      });
      console.log(clone);
      setOrdineTemp(clone);
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
  };

  async function salvaProdotto(e) {
    e.preventDefault();
    if (!canUpdateLogistica) {
      setAlertSalvataggio("Permesso update:logistica mancante.");
      return;
    }
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (ordineTemp.articoliArr?.some((articolo) =>
      articolo["Quantità"] == null || String(articolo["Quantità"]).trim() === "" ||
      !Number.isFinite(Number(articolo["Quantità"])) || Number(articolo["Quantità"]) < 0 ||
      (Number(articolo["Quantità"]) < 1 && !(Number(articolo["Quantità"]) === 0 && rimborsoPresente))
    )) {
      setAlertSalvataggio("Ogni articolo deve avere quantità almeno 1, oppure zero con un rimborso presente in questa spedizione. Correggi la quantità oppure usa il cestino per eliminarlo o spostarlo.");
      return;
    }
    if (!rimborsoPresente && ordineTemp.articoliArr?.some((articolo) => articolo.rimborso_articolo)) {
      setAlertSalvataggio("Per salvare gli articoli rimborsati deve essere presente un rimborso in questa spedizione.");
      return;
    }
    /* let registraCambio = false;
        if (ordineTemp.spedEclifor[0]["Partenza_da"] !== ordine.spedEclifor[0]["Partenza_da"]
            || ordineTemp.spedEclifor[0]["Stato_Ordine"] !== ordine.spedEclifor[0]["Stato_Ordine"]
        ) {
            registraCambio = true;
        } */
    if (ordineTemp.spedEclifor[0]["ID Spedizione"] === "NUOVO") {
      ////////////////// NUOVO ORDINE DA INSERIRE PER LA PRIMA VOLTA ///////////////////////////////
      try {
        const data = {
          ordine: ordineTemp,
          utente: utente.username,
          permessi: utente.permessiAPI,
          /* registraCambio: registraCambio */
        };
        const config = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        axios
          .patch(
            apiUrl + "/logistica/ordine/inserimentoORDINEsingoloQuerySep",
            data,
            config,
          )
          .then((resp) => {
            if (resp.data.errore) {
              setAlertSalvataggio(resp.data.errore);
            } else if (resp.data.errno) {
              setAlertSalvataggio(
                `Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`,
              );
            } else {
              setAlertSalvataggio(false);
              setResultSalvataggio(resp.data);
              setSalvato(true);
              setOrdineFunction("NO DATA");
            }
          });
      } catch (err) {
        console.log("Errore nell'invio del prodotto alle API': " + err);
        throw err;
      }
      /* try {
                setOrdineFunction("NO DATA");
            } catch (err) {
                console.log("Ho salvato e tutto ma mi sono incartato sul chiudere il prodotto: " + err)
                throw err;
            } */
    } else {
      //////////////////////////////// ORDINE DA AGGIORNARE ///////////////////////////////////
      try {
        const data = {
          ordine: ordineTemp,
          utente: utente.username,
          permessi: utente.permessiAPI,
          utenteOBJ: utente,
          //registraCambio: registraCambio
        };
        const config = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        axios
          .patch(
            apiUrl + "/logistica/ordine/salvataggioORDINEsingoloQuerySep",
            data,
            config,
          )
          .then((resp) => {
            if (resp.data.errore) {
              setAlertSalvataggio(resp.data.errore);
            } else if (resp.data.errno) {
              setAlertSalvataggio(
                `Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`,
              );
            } else {
              setAlertSalvataggio(false);
              setResultSalvataggio(resp.data);
              setSalvato(true);
              // Ricarico per allineare versione e id di note/articoli appena
              // inseriti: senza, il salvataggio successivo dello stesso utente
              // verrebbe respinto dal controllo conflitti.
              const idSpedizione = ordineTemp.spedEclifor[0]["ID Spedizione"];
              apriSpedizioneDaId(idSpedizione).catch((erroreRicarica) => {
                console.error("Errore ricarica spedizione salvata", erroreRicarica);
                setAlertSalvataggio(
                  `Spedizione ${idSpedizione} salvata, ma non è stato possibile ricaricarla: riaprila prima di fare altre modifiche.`,
                );
              });
            }
          });
      } catch (err) {
        console.log("Errore nell'invio del prodotto alle API': " + err);
        throw err;
      }
    }
  }

  async function rimuoviDaArr(arr, i) {
    setSalvato(false);
    const arrUpdate = ordineTemp[arr];
    arrUpdate.splice(i, 1);
    setOrdineTemp({
      ...ordineTemp,
      [arr]: arrUpdate,
    });
  }

  function chiudiSenzaSalvare(e) {
    e.preventDefault();
    setOrdineFunction("NO DATA");
  }

  function cambiaTab(e) {
    e.preventDefault();
    setTab(e.target.id);
  }

  function togliMailto(string) {
    return string.substring(0, string.indexOf("#"));
  }

  function aggiungArticolo() {
    if (!canUpdateLogistica) {
      return;
    }
    setSalvato(false);
    const articoloNuovo = {
      "ID Articolo": "",
      Categoria: "",
      Persona: "",
      "Codice EAN": "",
      "Cod Viglietti Sport": "",
      Produttore: "",
      "Descrizione Articolo": "",
      "Importo unitario": "",
      Quantità: 1,
      Spedito: null,
      artPeso: null,
      "MM Scarpone": null,
      Livello: null,
      "Totale riga": "0.00",
      PrezAcqConIVA: "0.00",
      TotPrezAcqConIVA: "0.00",
      Articolo_Personalizzato: 0,
    };
    setOrdineTemp({
      ...ordineTemp,
      articoliArr: [...ordineTemp.articoliArr, articoloNuovo],
    });
  }

  function aggiungReso() {
    if (!canUpdateLogistica) {
      return;
    }
    setSalvato(false);
    const resoNuovo = {
      resiTipo_reso: "",
      resiStato_reso: "",
      resiData_rientro: "",
      resiMezzo_rimborso: "",
      resiData_operazione: "",
      resiValore_merce: "",
      resiSpedizione_A: "",
      resiSpedizione_R: "",
      resiTotale_rimborso: "",
      resiNote: "",
    };
    setOrdineTemp({
      ...ordineTemp,
      spedEclifor: [{ ...ordineTemp.spedEclifor[0], Reso: 1 }],
      resiErimborsiArr: [...ordineTemp.resiErimborsiArr, resoNuovo],
    });
  }

  // Le note stanno in Note_Spedizioni, fuori da Spedizioni.versione: su una
  // spedizione esistente si salvano da sole (anche con print:logistica) e non
  // rendono "non salvata" la spedizione né generano conflitti di versione.
  function aggiungiNota(contenuto = "", tipoNota = "fontinaUser") {
    if (!canScrivereNote) {
      return null;
    }
    if (spedizioneNuova) {
      setSalvato(false);
    }
    const notaNuova = {
      nomeUtente: utente.username,
      contenuto,
      dataNota: new Date(),
      tipoNota,
      daSalvare: true,
    };
    const indice = ordineTemp.noteArr.length;
    setOrdineTemp((precedente) => ({
      ...precedente,
      noteArr: [...precedente.noteArr, notaNuova],
    }));
    return { nota: notaNuova, indice };
  }

  function aggiungiNotaRapida(contenuto, tipoNota) {
    const aggiunta = aggiungiNota(contenuto, tipoNota);
    if (aggiunta && !spedizioneNuova) {
      salvaNota(aggiunta.indice, aggiunta.nota).catch((err) =>
        setAlertSalvataggio(err.message),
      );
    }
  }

  async function salvaNota(indice, nota = ordineTemp.noteArr[indice]) {
    if (!canScrivereNote || spedizioneNuova || !nota) {
      return;
    }
    if (!utente?.username) {
      throw new Error("Username Domino mancante: ricarica il profilo prima di salvare la nota.");
    }
    try {
      const accessToken = await getAccessTokenSilently();
      const resp = await axios.post(
        apiUrl + "/logistica/ordine/salvaNotaSpedizione",
        {
          idSped: ordineTemp.spedEclifor[0]["ID Spedizione"],
          nota: { id: nota.id, contenuto: nota.contenuto, tipoNota: nota.tipoNota },
          utente: utente.username,
          utenteOBJ: utente,
        },
        { headers: { Authorization: "Bearer " + accessToken } },
      );
      const salvata = resp.data?.nota;
      if (!salvata?.id) {
        throw new Error(resp.data?.errore || "Risposta di salvataggio nota non valida.");
      }
      setOrdineTemp((precedente) => {
        const noteArr = [...precedente.noteArr];
        const corrente = noteArr[indice] || {};
        noteArr[indice] = {
          ...corrente,
          ...salvata,
          contenuto: corrente.contenuto ?? salvata.contenuto,
          daSalvare: (corrente.contenuto ?? salvata.contenuto) !== salvata.contenuto,
        };
        return { ...precedente, noteArr };
      });
    } catch (err) {
      throw new Error(
        getMessaggioErroreInserimento(
          err.response?.data,
          err.message || "Errore nel salvataggio della nota.",
        ),
      );
    }
  }

  async function eliminaNotaPropria(indice, nota) {
    if (!canScrivereNote || !nota?.id) {
      return;
    }
    if (!utente?.username) {
      throw new Error("Username Domino mancante: ricarica il profilo prima di cancellare la nota.");
    }
    try {
      const accessToken = await getAccessTokenSilently();
      await axios.post(
        apiUrl + "/logistica/ordine/eliminaNotaSpedizione",
        {
          idSped: ordineTemp.spedEclifor[0]["ID Spedizione"],
          idNota: nota.id,
          utente: utente.username,
        },
        { headers: { Authorization: "Bearer " + accessToken } },
      );
    } catch (err) {
      throw new Error(
        getMessaggioErroreInserimento(
          err.response?.data,
          err.message || "Errore nella cancellazione della nota.",
        ),
      );
    }
    setOrdineTemp((precedente) => ({
      ...precedente,
      noteArr: precedente.noteArr.filter((notaArr) => notaArr.id !== nota.id),
    }));
  }

  const handleChangeNota = function (evt) {
    if (spedizioneNuova) {
      setSalvato(false);
    }
    const { name, value } = evt.target;
    const match = name.match(/^noteArr\[(\d+)\]/);
    setOrdineTemp((precedente) => {
      const update = _.set(_.cloneDeep(precedente), name, value);
      if (match) {
        update.noteArr[match[1]].daSalvare = true;
      }
      return update;
    });
  };

  function rimuoviBozzaNota(indice) {
    if (spedizioneNuova) {
      setSalvato(false);
    }
    setOrdineTemp((precedente) => ({
      ...precedente,
      noteArr: precedente.noteArr.filter((_nota, i) => i !== indice),
    }));
  }

  function toDate(stringDate) {
    if (stringDate) {
      var d = new Date(stringDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    } else {
      return null;
    }
  }

  function switchaBoolGenerico(dato, nomeDato) {
    setSalvato(false);
    console.log(dato, nomeDato);
    let value;
    if (dato === 1) {
      value = 0;
    } else if (dato === 0) {
      value = 1;
    }
    const update = _.set(_.cloneDeep(ordineTemp), nomeDato, value);

    setOrdineTemp(update);
  }

  function getMessaggioErroreInserimento(respData, fallback) {
    if (respData?.errore) {
      return respData.errore;
    }
    if (respData?.errno) {
      return `Errore nel salvataggio: ${respData.code || ""} - ${
        respData.message || respData.errno
      }`;
    }
    if (respData?.error) {
      return respData.missing_permission
        ? `${respData.error}: permesso mancante ${respData.missing_permission}`
        : respData.error;
    }
    return fallback;
  }

  async function inserisciOrdineDuplicato(duplicato) {
    if (!canUpdateLogistica) {
      setAlertSalvataggio("Permesso update:logistica mancante.");
      return;
    }
    if (!token) {
      setAlertSalvataggio(
        "Token non ancora disponibile. Riprova tra un attimo.",
      );
      return;
    }

    try {
      const data = {
        ordine: duplicato,
        utente: utente.username,
        permessi: utente.permessiAPI,
      };
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      const resp = await axios.patch(
        apiUrl + "/logistica/ordine/inserimentoORDINEsingoloQuerySep",
        data,
        config,
      );
      const erroreInserimento = getMessaggioErroreInserimento(resp.data);
      if (erroreInserimento) {
        setAlertSalvataggio(erroreInserimento);
        return;
      }

      setAlertSalvataggio(false);
      setResultSalvataggio(resp.data);
      setSalvato(true);
      const idSpedizioneCreata =
        resp.data?.idSpedizione ?? resp.data?.resSped?.insertId;
      try {
        await apriSpedizioneDaId(idSpedizioneCreata);
      } catch (erroreApertura) {
        console.error("Errore apertura spedizione duplicata", erroreApertura);
        setAlertSalvataggio(
          `Spedizione ${idSpedizioneCreata} creata, ma non è stato possibile aprirla automaticamente.`,
        );
      }
    } catch (err) {
      const messaggio = getMessaggioErroreInserimento(
        err.response?.data,
        err.message || "Errore nell'invio dell'ordine alle API.",
      );
      console.log("Errore nell'invio dell'ordine alle API': " + messaggio);
      setAlertSalvataggio(messaggio);
    }
  }

  async function duplicaOrdine() {
    console.log("duplicato");
    const adesso = new Date();
    const duplicato = {
      spedEclifor: [
        {
          ...ordineTemp.spedEclifor[0],
          "ID CliFor": null,
          "ID Spedizione": null,
          Data_inserimento_Spedizione: adesso,
          Tipo: "Nuova spedizione",
          Causale: null,
          Stato_Ordine: "PREPARAZIONE",
          Promemoria: 0,
          Causale_Stato: null,
          Data: adesso,
          N_doc_trasporto: null,
          Tipo_doc_trasp: "",
          Data_Preparazione: null,
          Data_partenza: null,
          Spese_di_spedizione: null,
          Spese_di_contrassegno: null,
          Tipo_di_pagamento: null,
          Tot_imp_contrassegno: null,
          Tot_imp_spedizione: null,
          Emissione_scontrino: null,
          N_Trakking: null,
          Reso: 0,
          statoMag: null,
          magazzinoStatoMag: null,
          dataStatoMag: null,
        },
      ],
    };

    console.log(duplicato);

    await inserisciOrdineDuplicato(duplicato);
  }

  async function duplicaOrdineConArticoli() {
    const adesso = new Date();
    const duplicato = {
      spedEclifor: [
        {
          ...ordineTemp.spedEclifor[0],
          "ID CliFor": null,
          "ID Spedizione": null,
          Data_inserimento_Spedizione: adesso,
          Tipo: "Nuova spedizione",
          Causale: null,
          Stato_Ordine: "PREPARAZIONE",
          Promemoria: 0,
          Causale_Stato: null,
          Data: adesso,
          N_doc_trasporto: null,
          Tipo_doc_trasp: "",
          Data_Preparazione: null,
          Data_partenza: null,
          Spese_di_spedizione: null,
          Spese_di_contrassegno: null,
          Tipo_di_pagamento: null,
          Tot_imp_contrassegno: null,
          Tot_imp_spedizione: null,
          Emissione_scontrino: null,
          N_Trakking: null,
          Reso: 0,
          statoMag: null,
          magazzinoStatoMag: null,
          dataStatoMag: null,
        },
      ],
    };
    duplicato.articoliArr = ordineTemp.articoliArr.map((art) => {
      return {
        ...art,
        ID: null,
        "ID Spedizione": null,
        "ID Articoli": null,
        "ID Articolo": null,
      };
    });
    console.log(duplicato);
    await inserisciOrdineDuplicato(duplicato);
  }

  // STATE per la selezione articoli da splittare
  const [articoliDaSplittare, setArticoliDaSplittare] = useState([]);
  const [splitModalOpen, setSplitModalOpen] = useState(false);
  const [splitInCorso, setSplitInCorso] = useState(false);

  function toggleArticoloSplit(idArticolo) {
    setArticoliDaSplittare((prev) => {
      if (prev.includes(idArticolo)) {
        return prev.filter((id) => id !== idArticolo);
      } else {
        return [...prev, idArticolo];
      }
    });
  }

  async function splittaOrdine(idArticoli = articoliDaSplittare) {
    if (!canUpdateLogistica || splitInCorso) return;
    if (!salvato) {
      setAlert("Salva le modifiche prima di spostare articoli in un’altra spedizione.");
      return;
    }
    if (idArticoli.length === 0 || idArticoli.some((id) => !id)) {
      setAlert("Seleziona almeno un articolo da spostare nel nuovo ordine.");
      return;
    }

    setSplitInCorso(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const data = {
        idOrdine: ordineTemp.spedEclifor[0]["ID Spedizione"],
        idArticoli,
        magazzino: null, // Opzionale: magazzino di destinazione
        utente: utente.username,
      };

      const response = await axios.post(
        apiUrl + "/logistica/ordine/splittaOrdineManuale",
        data,
        { headers: { Authorization: "Bearer " + accessToken } },
      );

      if (response.data.status === "OK") {
        setAlert("Ordine splittato. Nuovo ID: " + response.data.newId);
        setSplitModalOpen(false);
        setArticoliDaSplittare([]);
        try {
          await apriSpedizioneDaId(response.data.newId);
        } catch (erroreApertura) {
          console.error("Errore apertura nuova spedizione split", erroreApertura);
          setAlert(
            `Ordine splittato nel nuovo ID ${response.data.newId}, ma non è stato possibile aprirlo automaticamente.`,
          );
        }
      } else {
        setAlert("Errore nello split: " + JSON.stringify(response.data));
      }
    } catch (err) {
      console.log("Errore nello split ordine: " + err);
      setAlert("Errore: " + err.message);
    } finally {
      setSplitInCorso(false);
    }
  }

  async function cancellaSpedizione() {
    let idArticoli;
    if (ordineTemp.articoliArr && Array.isArray(ordineTemp.articoliArr)) {
      idArticoli = ordineTemp.articoliArr.map((art) => art["ID Articolo"]);
    }

    try {
      const data = {
        idCliFor: ordineTemp.spedEclifor[0]["ID CliFor"],
        idSped: ordineTemp.spedEclifor[0]["ID Spedizione"],
        arrIDart: idArticoli,
        username: utente.username,
      };
      const dataToSend = JSON.stringify(data);
      let request = new XMLHttpRequest();
      request.open("DELETE", apiUrl + "/logistica/ordine/cancellaOrdine", true);
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + token);
      request.send(dataToSend);
    } catch (err) {
      console.log("Errore nell'invio del prodotto alle API': " + err);
      throw err;
    }
    try {
      setOrdineFunction("NO DATA");
    } catch (err) {
      console.log(
        "Ho salvato e tutto ma mi sono incartato sul chiudere il prodotto: " +
          err,
      );
      throw err;
    }
  }

  async function forzaCambioStato() {
    //TODO - al momento ho copiato qui le regole, riorganizzare questo controllo nelle api per farlo in un posto solo
    let statoPreparazionePerPS = "92";

    if (
      ordineTemp.spedEclifor[0]["Stato_Ordine"] === "IN ATTESA" ||
      ordineTemp.spedEclifor[0]["Stato_Ordine"] === "IN ATTESA BB" ||
      ordineTemp.spedEclifor[0]["Stato_Ordine"] === "SPEDIZIONE PRONTA"
    ) {
      //tutti gli ordini di cui NON voglio le etichette nelle aree corrieri
      statoPreparazionePerPS = "92";
    } else if (ordineTemp.spedEclifor[0]["Corriere"] === "UPS") {
      statoPreparazionePerPS = "36";
    } else if (
      ordineTemp.spedEclifor[0]["Corriere"] === "DHL" &&
      ordine["Market_Place"] === "Amazon"
    ) {
      statoPreparazionePerPS = "92";
    } else if (
      ordineTemp.spedEclifor[0]["Corriere"] === "DHL" &&
      ordine["Market_Place"] !== "Amazon"
    ) {
      statoPreparazionePerPS = "90";
    } /*  else if (ordine["Market_Place"] === "Amazon") {
                // se si vuole gestire Amazon a parte mettere 92
                statoPreparazionePerPS = "92"
            } */ else if (
      ordineTemp.spedEclifor[0]["codicePUDO"] &&
      ordineTemp.spedEclifor[0]["codicePUDO"].length > 1
    ) {
      //per il momento i fermopoint non sono supportati da plug&ship, quindi li gestisco a parte, anche questo sarà da cambiare
      statoPreparazionePerPS = "92";
    } else if (ordineTemp.spedEclifor[0]["Partenza_da"] === "Torino") {
      //per il momento non abbiamo aggiunto la tariffa di torino a plug&ship
      statoPreparazionePerPS = "92";
    } else if (ordineTemp.spedEclifor[0]["Corriere"] === "RITIRO NEGOZIO") {
      statoPreparazionePerPS = "92";
    } else if (
      ordineTemp.spedEclifor[0]["Corriere"] === "BRT" ||
      ordineTemp.spedEclifor[0]["Corriere"] === "DPD"
    ) {
      statoPreparazionePerPS = "3";
    }
    const idpS = ordineTemp.spedEclifor[0]["N_rif_PrestaShop"];
    const fonte = ordineTemp.spedEclifor[0]["fonte"] || "VIG";
    let request = new XMLHttpRequest();
    request.open(
      "PATCH",
      `${apiUrl}/logistica/ps/cambioStatoSuPS/${idpS}/${statoPreparazionePerPS}?fonte=${fonte}`,
      true,
    );
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("Authorization", "Bearer " + token);
    request.send();
  }

  async function cancellaRifPS() {
    const idSped = ordineTemp?.spedEclifor?.[0]?.["ID Spedizione"];
    if (!idSped) {
      alert("ID spedizione mancante.");
      return;
    }
    try {
      const payload = {
        tabella: "Spedizioni",
        campo: "N_rif_PrestaShop",
        nuovoValore: null,
        wheresComeRicercaDB: { "`ID Spedizione` =": idSped },
      };
      await axios.patch(`${apiUrl}/setValueSQL`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });
      alert("Riferimento PrestaShop cancellato.");
      setOrdineFunction("NO DATA");
    } catch (error) {
      console.error("Errore cancellazione rif PS", error);
      alert("Errore durante la cancellazione del rif. PS");
    }
  }

  function ricordamelo() {
    if (!ordineTemp.spedEclifor[0]["dataPromemoria"]) {
      alert(
        "Se non imposti una data per il promemoria non ti arriverà nulla, mai. Anche se la togli dopo, stessa cosa.",
      );
      return;
    } else {
      const notaAggiuntiva = prompt(
        "Vuoi aggiungere una nota al promemoria? Se non lo fai riceverai comunque una mail e una notifica con link all'ordine",
      );
      /* if (!token) {
                console.warn("sto aspettando un token")
                return;
            } TODO INSERIRE CONTROLLO  */
      const data = {
        nomeUtente: utente.nomeDisplayAlt,
        usernameUtente: utente.username,
        /* dataPromemoria: ordineTemp.spedEclifor[0]["dataPromemoria"], */ //questa in realtà la metto come dato della spedizione e la leggo dal cron delle notifiche, in modo da poterla cambiare in corso e annullare se la cosa si risolve prima
        idOrdinePS: ordineTemp.spedEclifor[0]["N_rif_PrestaShop"]
          ? ordineTemp.spedEclifor[0]["N_rif_PrestaShop"]
          : null,
        idOrdineDatabase: ordineTemp.spedEclifor[0]["ID Spedizione"],
        nomeCliente: ordineTemp.spedEclifor[0]["NomeCognome"],
        dataOrdine: ordineTemp.spedEclifor[0]["Data"],
        notaAggiuntiva: notaAggiuntiva,
      };
      /* const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                  }
            } TODO INSERIRE CONTROLLO  */
      axios
        .patch(apiUrl + "/promemoria/ordine", data /* , config */)
        .then(alert("Promemoria impostato!"));
      /* .then(res => {
                setAlertSalvataggio(res.data.resultsRicercaOrdini)
                handleChange({
                    target: {
                        name: 'articoliArr['+i+']["trovato"]',
                        value: valore
                    }
                })
            }) */
    }
  }

  function ciPensoIo() {
    setSalvato(false);
    let update;
    try {
      // NON SO SE SERVE CLONARE OGNI VOLTA MA HO FRETTA E FACCIO COSI'
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, 'spedEclifor[0]["userAttesa"]', utente.username);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  }

  function ciRipenso() {
    setSalvato(false);
    let update;
    try {
      // NON SO SE SERVE CLONARE OGNI VOLTA MA HO FRETTA E FACCIO COSI'
      const clone = _.cloneDeep(ordineTemp);
      _.set(clone, 'spedEclifor[0]["userAttesa"]', null);
      update = clone;
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato nestato: " + err);
      throw err;
    }
    setOrdineTemp(update);
  }

  /////////////////////////////////////////// COLONNE /////////////////////////////////////

  function riquadroSalvataggio() {
    return (
      <div className="">
        {alertSalvataggio && (
          <div className={riquadroClassesRed + " mb2"}>{alertSalvataggio}</div>
        )}
        {(usaNavigazionePaginata
          ? idOrdinePrecedente
          : indexOrdine > 0) && (
          <button
            className={buttonClassesWhite}
            disabled={navigazioneInCorso}
            onClick={precedente}
          >
            {tastoSXAspetto}
          </button>
        )}
        {!salvato && canUpdateLogistica && (
          <button
            className={buttonClassesGreen + " mb2"}
            onClick={salvaProdotto}
          >
            {tastoSalvaAspetto}
          </button>
        )}
        {(!salvato || noteDaSalvare) && (
          <button
            className={buttonClassesRed + " mb2"}
            onClick={chiudiSenzaSalvare}
          >
            {tastoChiudiAspetto}
          </button>
        )}
        {salvato && !noteDaSalvare && (
          <button
            className={buttonClassesGreen + " mb2"}
            onClick={chiudiSenzaSalvare}
          >
            {tastoChiudiAspetto}
          </button>
        )}
        {(usaNavigazionePaginata
          ? idOrdineSuccessivo
          : indexOrdine < listaId?.length - 1) && (
          <button
            className={buttonClassesWhite}
            disabled={navigazioneInCorso}
            onClick={successivo}
          >
            {tastoDXAspetto}
          </button>
        )}
        {alert && <h3 className="tastoRosso white">{alert}</h3>}
      </div>
    );
  }

  function riquadroDatiOrdine() {
    const speseSpedizione = leggiNumero(
      ordineTemp?.spedEclifor?.[0]?.Spese_di_spedizione,
    );
    return (
      <div>
        <h2>{ordineTemp?.spedEclifor?.[0]?.["nomeCliente"] ?? ""}</h2>
        <p>
          ID {ordine.spedEclifor[0]["ID Spedizione"]} - Data inserimento{" "}
          {ordine?.spedEclifor?.[0]?.["Data_inserimento_Spedizione"] &&
            umanizzaDataSenzaOre(
              ordine.spedEclifor[0]["Data_inserimento_Spedizione"],
            )}
        </p>
        {/* INIZIO GROSSO CASINO DEI BOOLEAN */}
        {utente.permessiAPI["update:database"] &&
          /* && ordineTemp?.spedEclifor?.[0]?.["Promemoria"] */
          ordineTemp.spedEclifor[0]["Promemoria"] === 1 && (
            <p
              className="br3 flex items-center pointer justify-center tastoRosso white pa2 fw5"
              onClick={(e) =>
                switchaBoolGenerico(
                  ordineTemp.spedEclifor[0]["Promemoria"],
                  "spedEclifor[0].Promemoria",
                )
              }
            >
              <span className="material-icons pr2">radio_button_checked</span>
              Promemoria!
            </p>
          )}
        {
          /* ordineTemp?.spedEclifor?.[0]?.["Promemoria"]
                        &&  */ ordineTemp.spedEclifor[0]["Promemoria"] === 0 &&
            utente.permessiAPI["update:database"] && (
              <p
                className="flex items-center justify-center pa2 pointer"
                onClick={(e) =>
                  switchaBoolGenerico(
                    ordineTemp.spedEclifor[0]["Promemoria"],
                    "spedEclifor[0].Promemoria",
                  )
                }
              >
                <span className="material-icons scrittaColoreAltScuro pr2">
                  radio_button_unchecked
                </span>
                Attiva promemoria
              </p>
            )
        }
        {!utente.permessiAPI["update:database"] &&
          ordineTemp.spedEclifor[0]["Promemoria"] === 1 && (
            <p className="br3 flex items-center justify-center tastoRosso white pa2 fw5">
              <span className="material-icons pr2">radio_button_checked</span>
              Promemoria!
            </p>
          )}
        {/* FINE GROSSO CASINO DEI BOOLEAN */}
        <div className="flex flex-wrap justify-between">
          <InputDatoProdotto
            inputLabel="Rif. P.S."
            datoName='spedEclifor[0]["N_rif_PrestaShop"]'
            datoId="N_rif_PrestaShop"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["N_rif_PrestaShop"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-80"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              /*utente.permessiAPI["update:database"] ? "SI" : */ "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Cliente"
            datoName='spedEclifor[0]["nomeCliente"]'
            datoId="nomeCliente"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["nomeCliente"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Tipo"
            datoName='spedEclifor[0]["Tipo"]'
            elencoDati={datiTendineOrdine.tipoOrdine}
            datoId="tipo"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Tipo"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Causale"
            datoName='spedEclifor[0]["Causale"]'
            elencoDati={datiTendineOrdine.causaleSped}
            datoId="causale"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Causale"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Marketpl"
            datoName='spedEclifor[0]["Market_Place"]'
            elencoDati={datiTendineOrdine.marketplace}
            datoId="dataOrdine"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Market_Place"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Data ordine"
            tipoInput="date"
            datoName='spedEclifor[0]["Data"]'
            datoId="dataOrdine"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Data"] &&
              toDate(
                ordineTemp.spedEclifor[0]["Data"],
              ) /* ? umanizzaDataSenzaSecondi(ordineTemp?.spedEclifor?.[0]?.["Data"]) : "" */
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Rif. M.P."
            datoName='spedEclifor[0]["N_rif_MarketPlace"]'
            datoId="N_rif_MarketPlace"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["N_rif_MarketPlace"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Pagamento"
            datoName='spedEclifor[0]["Tipo_di_pagamento"]'
            elencoDati={datiTendineOrdine.pagamento}
            datoId="pagamento"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Tipo_di_pagamento"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Data accredito BB"
            tipoInput="date"
            datoName='spedEclifor[0]["Data_accredito_BB"]'
            datoId="dataBB"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Data_accredito_BB"] &&
              toDate(ordineTemp.spedEclifor[0]["Data_accredito_BB"])
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Scontrino"
            datoName='spedEclifor[0]["Emissione_scontrino"]'
            elencoDati={datiTendineOrdine.scontrino}
            datoId="scontrino"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Emissione_scontrino"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Importo sped."
            datoName='spedEclifor[0]["Tot_imp_spedizione"]'
            tipoInput="number"
            datoId="Tot_imp_spedizione"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Tot_imp_spedizione"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          {speseSpedizione > 0 && (
            <div className={`f7 ${speseSpedizione > 20 ? "dark-red" : "gray"} mt1`}>
              (Spese di spedizione: {speseSpedizione.toFixed(2)} €)
            </div>
          )}
          {Number(ordineTemp?.spedEclifor?.[0]?.["Tot_imp_contrassegno"]) >
            0 && (
            <div className="f7 gray mt1">
              (Importo contrassegno:{" "}
              {Number(
                ordineTemp?.spedEclifor?.[0]?.["Tot_imp_contrassegno"],
              ).toFixed(2)}
              €)
            </div>
          )}
        </div>
      </div>
    );
  }

  function riquadroStatoOrdine() {
    return (
      <div>
        {/* TODO limita il tasto attese in base ai permessi */}
        {/* {utente.permessiAPI["update:database"] && <div className="tc"><button className={buttonClassesAttesa + " mb3"} onClick={magAssenteMandaTO}>Mag assente, ATTESA+TO</button></div>} */}

        <InputDatoTendinaGenerico
          inputLabel="Stato ordine"
          datoName='spedEclifor[0]["Stato_Ordine"]'
          elencoDati={datiTendineOrdine.statoOrdine}
          datoId="statoOrdine"
          datoValue={ordineTemp?.spedEclifor?.[0]?.["Stato_Ordine"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChangeStato}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <InputDatoTendinaGenerico
          inputLabel="Causa stato"
          datoName='spedEclifor[0]["Causale_Stato"]'
          elencoDati={datiTendineOrdine.causaleStato}
          datoId="causaleStato"
          datoValue={ordineTemp?.spedEclifor?.[0]?.["Causale_Stato"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="Data prep."
          tipoInput="date"
          datoName='spedEclifor[0]["Data_Preparazione"]'
          datoId="dataPrep"
          datoValue={
            ordineTemp?.spedEclifor?.[0]?.["Data_Preparazione"] &&
            toDate(ordineTemp.spedEclifor[0]["Data_Preparazione"])
          }
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="Data partenza"
          tipoInput="date"
          datoName='spedEclifor[0]["Data_partenza"]'
          datoId="dataPart"
          datoValue={
            ordineTemp?.spedEclifor?.[0]?.["Data_partenza"] &&
            toDate(ordineTemp.spedEclifor[0]["Data_partenza"])
          }
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <div className="flex items-start w-100">
          <InputDatoTendinaGenerico
            inputLabel="Partenza da"
            datoName='spedEclifor[0]["Partenza_da"]'
            elencoDati={datiTendineOrdine.partenzaDa}
            datoId="partenzaDa"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Partenza_da"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={bloccoMagazzinoPartenza ? "w-90" : "w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              !bloccoMagazzinoPartenza && utente.permessiAPI["update:database"]
                ? "SI"
                : "NO"
            }
          />
          {bloccoMagazzinoPartenza && (
            <div
              className="partenzaDaLockTooltip tooltip ml2 mt1"
              aria-label="Magazzino di partenza bloccato"
            >
              <span className="material-icons scrittaColScuro">lock</span>
              <div className="tooltiptext">
                Il magazzino di partenza è bloccato perché qualcuno sta cercando
                la merce, un'etichetta è stata stampata o l'ordine è già stato
                gestito. Per cambiare il magazzino di partenza imposta lo stato
                come ATTESA ma assicurati di non creare conflitti di magazzini o
                lasciare etichette compromettenti nel magazzino sbagliato.
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function riquadroDatiSpedizioneCliente(height) {
    return (
      <div className={"h-" + height + "-ns"}>
        <div className="colonna85vh sezioneConScroll">
          <div className="flex flex-wrap justify-between">
            <h3>Dati spedizione cliente</h3>
            <InputDatoProdotto
              inputLabel="Cliente PS"
              datoName='spedEclifor[0]["nomeCliente"]'
              datoId="nomeCliente"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["nomeCliente"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={"NO"}
            />
            <InputDatoProdotto
              inputLabel="Nome sped"
              datoName='spedEclifor[0]["NomeCognome"]'
              datoId="NomeCognome"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["NomeCognome"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="P.IVA / C.F."
              datoName='spedEclifor[0]["PIva CF"]'
              datoId="pIVA"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["PIva CF"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Società"
              datoName='spedEclifor[0]["Società"]'
              datoId="society"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Società"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Indirizzo 1"
              datoName='spedEclifor[0]["Indirizzo"]'
              datoId="ind1"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Indirizzo"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Indirizzo 2"
              datoName='spedEclifor[0]["Indirizzo_2"]'
              datoId="ind2"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Indirizzo_2"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="C/O"
              datoName='spedEclifor[0]["C/O"]'
              datoId="careof"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["C/O"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="CAP"
              datoName='spedEclifor[0]["CAP"]'
              datoId="cap"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["CAP"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-60 h-100"}
              datoClass={"w-60"}
              labelClass={"w-30"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Prov"
              datoName='spedEclifor[0]["Provincia"]'
              datoId="provincia"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Provincia"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-70 h-100"}
              datoClass={"w-30"}
              labelClass={"w-30"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Città"
              datoName='spedEclifor[0]["Città"]'
              datoId="city"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Città"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputTendinaDatoProdotto
              inputLabel="Nazione"
              datoName='spedEclifor[0]["Paese di provenienza"]'
              datoId="nazione"
              datoOnChange={handleChange}
              datoClass={inputClassesNOW + " w-80 h-80"}
              objOpzioni={datiTendineOrdine.nomiNazioni}
              datoValue={
                ordineTemp?.spedEclifor?.[0]?.["Paese di provenienza"] ?? ""
              }
              bloccoClass={"w-100"}
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
              labelOrizzontale="SI"
            />
            <div className="w-100 items-center flex justify-between mb1">
              <InputTendinaDatoProdotto
                inputLabel="cod Nazione"
                datoName='spedEclifor[0]["Cod_Paese"]'
                datoId="Cod_Paese"
                datoOnChange={handleChange}
                datoClass={inputClassesNOW + " w-80 h-100"}
                objOpzioni={datiTendineOrdine.codiceNazioni}
                datoValue={ordineTemp?.spedEclifor?.[0]?.["Cod_Paese"] ?? ""}
                bloccoClass={"w-70"}
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
                labelOrizzontale="SI"
              />
              <div className="w-20 b">
                {ordineTemp?.spedEclifor?.[0]?.["Cod_Paese"] ?? ""}
              </div>
            </div>
            <div className="w-100 items-center flex justify-between mb1">
              <InputTendinaDatoProdotto
                inputLabel="Prefisso"
                datoName='spedEclifor[0]["TEL_Prefix"]'
                datoId="TEL_Prefix"
                datoOnChange={handleChange}
                datoClass={inputClassesNOW + " w-80 h-80"}
                objOpzioni={datiTendineOrdine.prefissoNazione}
                datoValue={ordineTemp?.spedEclifor?.[0]?.["TEL_Prefix"] ?? ""}
                bloccoClass={"w-70"}
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
                labelOrizzontale="SI"
              />
              <div className="w-20 b">
                {ordineTemp?.spedEclifor?.[0]?.["TEL_Prefix"] ?? ""}
              </div>
            </div>
            <InputDatoProdotto
              inputLabel="Tel Cell"
              datoName='spedEclifor[0]["Telefono cell"]'
              datoId="telCell"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Telefono cell"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="Tel Fisso"
              datoName='spedEclifor[0]["Telefono fisso"]'
              datoId="telFisso"
              datoValue={ordineTemp?.spedEclifor?.[0]?.["Telefono fisso"] ?? ""}
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-100"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            <InputDatoProdotto
              inputLabel="eMail"
              datoName='spedEclifor[0]["E-mail"]'
              datoId="eMail"
              datoValue={
                ordineTemp?.spedEclifor?.[0]?.["E-mail"] &&
                ordineTemp?.spedEclifor?.[0]?.["E-mail"].includes("#")
                  ? togliMailto(ordineTemp.spedEclifor[0]["E-mail"])
                  : ordineTemp?.spedEclifor?.[0]?.["E-mail"] &&
                    ordineTemp.spedEclifor[0]["E-mail"]
              }
              datoPlaceHolder=""
              datoOnChange={handleChange}
              inputClass={inputClassesNOW + " w-80 h-100"}
              datoClass={"w-90"}
              labelClass={"wpx-60"}
              classiTastoSblocco={classiTastoSblocco}
              tastoCopiaAspetto="NO"
              modCompatta="SI"
              permessoScrittura={
                utente.permessiAPI["update:database"] ? "SI" : "NO"
              }
            />
            {ordineTemp?.spedEclifor?.[0]?.["E-mail"] && (
              <a
                className="linkMail material-icons mb2"
                href={
                  "mailto:" + togliMailto(ordineTemp.spedEclifor[0]["E-mail"])
                }
              >
                mail
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }

  function riquadroNote(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Note</h3>

        {ordineTemp?.spedEclifor?.[0]?.["Note"] &&
          ordineTemp.spedEclifor[0]["Note"] !== "" &&
          ordineTemp.spedEclifor[0]["Note"] !== " " &&
          ordineTemp.spedEclifor[0]["Note"] !== "#" &&
          ordineTemp.spedEclifor[0]["Note"] !== "0" && (
            <Nota
              nota={{
                nomeUtente: "notaPreEsistente",
                dataNota: ordineTemp.spedEclifor[0]["Data"],
                contenuto: ordineTemp.spedEclifor[0]["Note"],
              }}
              rimuoviDaArr={rimuoviDaArr}
              utente={utente}
              handleChange={handleChange}
              i={-1}
              tabellaNote={"Note_Spedizioni"}
              token={token}
            />
          )}
        {ordineTemp?.noteArr?.length > 0 && (
          <div className="">
            {ordineTemp.noteArr.map((note, i) => (
              <Nota
                utente={utente}
                nota={note}
                handleChange={handleChangeNota}
                rimuoviDaArr={rimuoviDaArr}
                rimuoviBozza={rimuoviBozzaNota}
                onSalvaNota={spedizioneNuova ? undefined : salvaNota}
                onEliminaNota={spedizioneNuova ? undefined : eliminaNotaPropria}
                canScrivereNote={canScrivereNote}
                i={i}
                key={note.id ?? `bozza-${i}`}
                tabellaNote={"Note_Spedizioni"}
                token={token}
                arrLength={ordineTemp.noteArr.length}
              />
            ))}
          </div>
        )}

        {canScrivereNote && (
          <>
            <div className="tc mt4">
              <div
                className="ba material-icons pa2 br-100 bordoColAlt scrittaColAltScuro pointer"
                onClick={() => aggiungiNota()}
              >
                add
              </div>
            </div>
            <div className="tc mt3">
              <div
                className="no-underline underline-hover bordoColAlt scrittaColAltScuro pointer"
                onClick={() =>
                  aggiungiNotaRapida(
                    "Dato spedito per metriche Amazon",
                    "datoSpeditoPerMetriche",
                  )
                }
              >
                Spedito per metriche
              </div>
            </div>
            <div className="tc mt3">
              <div
                className="no-underline underline-hover bordoColAlt scrittaColAltScuro pointer"
                onClick={() =>
                  aggiungiNotaRapida("Chiedere a Torino", "chiedereATO")
                }
              >
                Chiedere a TO
              </div>
            </div>
            <div className="tc mt3">
              <div
                className="no-underline underline-hover bordoColAlt scrittaColAltScuro pointer"
                onClick={() =>
                  aggiungiNotaRapida("Non sceso su Prestashop", "nonScesoSuPS")
                }
              >
                Non sceso su PS
              </div>
            </div>
          </>
        )}
      </div>
    );
  }

  function riquadroArticoli(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Articoli</h3>
        {ordineTemp?.articoliArr?.length > 0 && (
          <div className="">
            {ordineTemp.articoliArr.map((art, i) => {
              return (
                <Articolo
                  permessi={utente.permessiAPI}
                  handleChangeImportoArticolo={handleChangeImportoArticolo}
                  onRimborsaArticolo={(quantita) => rimborsaArticolo(i, quantita)}
                  rimborsoPresente={rimborsoPresente}
                  utente={utente}
                  articolo={art}
                  handleChange={handleChange}
                  i={i}
                  key={i}
                  idOrdinePS={
                    ordine.spedEclifor[0]["N_rif_PrestaShop"]
                      ? ordine.spedEclifor[0]["N_rif_PrestaShop"]
                      : false
                  }
                  idOrdineDatabase={ordine.spedEclifor[0]["ID Spedizione"]}
                  fonteOrdine={ordine.spedEclifor[0]["fonte"]}
                  magazziniAttivi={ordineTemp.magazziniAttivi}
                  rimuoviDaArr={rimuoviDaArr}
                  onArticoloSpostato={() => setOrdineFunction("NO DATA")}
                  onCreaSplit={(idArticolo) => splittaOrdine([idArticolo])}
                  splitInCorso={splitInCorso}
                  modificheNonSalvate={!salvato}
                />
              );
            })}
          </div>
        )}

        {canUpdateLogistica && (
          <div className="tc mt4">
            <div
              className="ba material-icons pa2 br-100 bordoColAlt scrittaColAlt pointer nonSelezionabile"
              onClick={aggiungArticolo}
            >
              add
            </div>
          </div>
        )}
      </div>
    );
  }

  function riquadroCorrieri(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Corrieri</h3>
        <div className="pa4  items-center flex flex-wrap justify-between">
          <InputDatoProdotto
            inputLabel="Spese sped"
            datoName='spedEclifor[0]["Spese_di_spedizione"]'
            tipoInput="number"
            datoId="Spese_di_spedizione"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Spese_di_spedizione"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Costo sped"
            datoName='spedEclifor[0]["Costo_spedizione"]'
            tipoInput="number"
            datoId="Costo_spedizione"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Costo_spedizione"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Porto franco"
            datoName='spedEclifor[0]["Porto"]'
            elencoDati={datiTendineOrdine.portoFranco}
            datoId="Porto"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Porto"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Spese c/ass"
            datoName='spedEclifor[0]["Spese_di_contrassegno"]'
            datoId="Spese_di_contrassegno"
            tipoInput="number"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Spese_di_contrassegno"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Tot imp. c/ass"
            datoName='spedEclifor[0]["Tot_imp_contrassegno"]'
            tipoInput="number"
            datoId="Tot_imp_contrassegno"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["Tot_imp_contrassegno"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Colli"
            datoName='spedEclifor[0]["N_Colli"]'
            tipoInput="number"
            datoId="N_Colli"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["N_Colli"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Peso in kg"
            datoName='spedEclifor[0]["Peso"]'
            tipoInput="number"
            datoId="Peso"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Peso"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-45"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <div className="w-100 mb2">Dimensioni collo/i</div>
          <InputDatoProdotto
            inputLabel="L"
            datoName='spedEclifor[0]["Dim_Collo_L"]'
            tipoInput="number"
            datoId="Dim_Collo_L"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Dim_Collo_L"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-30"}
            labelClass={"wpx-30"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="A"
            datoName='spedEclifor[0]["Dim_Collo_H"]'
            tipoInput="number"
            datoId="Dim_Collo_H"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Dim_Collo_H"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-30"}
            labelClass={"wpx-30"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="P"
            datoName='spedEclifor[0]["Dim_Collo_P"]'
            tipoInput="number"
            datoId="Dim_Collo_P"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Dim_Collo_P"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-30"}
            labelClass={"wpx-30"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          {/* INIZIO GROSSO CASINO DEI BOOLEAN */}
          {ordineTemp.spedEclifor[0]["Richiesto_fermo_deposito"] === 1 &&
            utente.permessiAPI["update:database"] && (
              <p
                className="w-20 br3 flex items-center justify-center pointer colReso white fw5"
                onClick={(e) =>
                  switchaBoolGenerico(
                    ordineTemp.spedEclifor[0]["Richiesto_fermo_deposito"],
                    "spedEclifor[0].Richiesto_fermo_deposito",
                  )
                }
              >
                <span className="material-icons pr2">radio_button_checked</span>
                Richiesto fermo deposito
              </p>
            )}
          {ordineTemp.spedEclifor[0]["Richiesto_fermo_deposito"] === 0 &&
            utente.permessiAPI["update:database"] && (
              <p
                className="w-20 flex items-center justify-center pointer"
                onClick={(e) =>
                  switchaBoolGenerico(
                    ordineTemp.spedEclifor[0]["Richiesto_fermo_deposito"],
                    "spedEclifor[0].Richiesto_fermo_deposito",
                  )
                }
              >
                <span className="material-icons scrittaColoreAltScuro pr2">
                  radio_button_unchecked
                </span>
                Fermo deposito
              </p>
            )}
          {!utente.permessiAPI["update:database"] &&
            ordineTemp.spedEclifor[0]["Richiesto_fermo_deposito"] === 1 && (
              <p className="w-20 br3 flex items-center justify-center pointer colReso white fw5">
                <span className="material-icons pr2">radio_button_checked</span>
                Richiesto fermo deposito
              </p>
            )}
          {/* FINE GROSSO CASINO DEI BOOLEAN */}

          <InputDatoProdotto
            inputLabel="Sede fermo deposito"
            datoName='spedEclifor[0]["Fermo_deposito"]'
            datoId="Fermo_deposito"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Fermo_deposito"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-70"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoTendinaGenerico
            inputLabel="Corriere"
            datoName='spedEclifor[0]["Corriere"]'
            elencoDati={datiTendineOrdine.corriere}
            datoId="Corriere"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["Corriere"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Tracking"
            datoName='spedEclifor[0]["N_Trakking"]'
            datoId="N_Trakking"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["N_Trakking"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <label for="noteCorr" className="w-100">
            Note corriere
          </label>
          {utente.permessiAPI["update:database"] ? (
            <textarea
              type="text"
              rows="5"
              id="noteCorr"
              name='spedEclifor[0]["Note_Corriere"]'
              value={ordineTemp?.spedEclifor?.[0]?.["Note_Corriere"] ?? ""}
              onChange={handleChange}
              className={inputClassesNOW + " w-100"}
            />
          ) : (
            <p>{ordineTemp?.spedEclifor?.[0]?.["Note_Corriere"] ?? ""}</p>
          )}

          {(ordineTemp?.spedEclifor?.[0]?.["Corriere"] === "BRT" ||
            ordineTemp?.spedEclifor?.[0]?.["Corriere"] === "DPD") && (
            <div className="flex flex-wrap justify-between items-center riqBRT">
              <div className="w-100 fw5 b mt3 mb1">BRT/DPD</div>
              <InputDatoTendinaGenerico
                inputLabel="Network"
                datoName='spedEclifor[0]["Network"]'
                elencoDati={datiTendineOrdine.brtNetwork}
                datoId="brtNetwork"
                datoValue={ordineTemp?.spedEclifor?.[0]?.["Network"] ?? ""}
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
              <InputDatoProdotto
                inputLabel="Cod tariffa"
                datoName='spedEclifor[0]["Cod_tariffa"]'
                datoId="brtCod_tariffa"
                datoValue={ordineTemp?.spedEclifor?.[0]?.["Cod_tariffa"] ?? ""}
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
              <InputDatoTendinaGenerico
                inputLabel="Tipo servizio"
                datoName='spedEclifor[0]["Tipo_servizio"]'
                elencoDati={datiTendineOrdine.brtServizio}
                datoId="brtServizio"
                datoValue={
                  ordineTemp?.spedEclifor?.[0]?.["Tipo_servizio"] ?? ""
                }
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
              <InputDatoProdotto
                inputLabel="Codice PUDO"
                datoName='spedEclifor[0]["codicePUDO"]'
                datoId="codicePUDO"
                datoValue={ordineTemp?.spedEclifor?.[0]?.["codicePUDO"] ?? ""}
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
            </div>
          )}
          {ordineTemp?.spedEclifor?.[0]?.["Corriere"] === "DHL" && (
            <div className="flex flex-wrap justify-between items-center riqDHL">
              <div className="w-100 fw5 b mt3 mb1">DHL</div>
              <InputDatoTendinaGenerico
                inputLabel="Tipo"
                datoName='spedEclifor[0]["DHL_Tipo_Sped"]'
                elencoDati={datiTendineOrdine.dhlTipo}
                datoId="dhlTipo"
                datoValue={
                  ordineTemp?.spedEclifor?.[0]?.["DHL_Tipo_Sped"] ?? ""
                }
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
              <InputDatoTendinaGenerico
                inputLabel="Dog"
                datoName='spedEclifor[0]["DHL_Dogana"]'
                elencoDati={datiTendineOrdine.dhlDog}
                datoId="dhlDog"
                datoValue={ordineTemp?.spedEclifor?.[0]?.["DHL_Dogana"] ?? ""}
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
              {/* dhl - conssab */}
              <div className="w-100 items-center flex justify-between mb2">
                <InputTendinaDatoProdotto
                  inputLabel="Cod paese"
                  datoName='spedEclifor[0]["DHL_Cod_Paese"]'
                  datoId="DHL_Cod_Paese"
                  datoOnChange={handleChange}
                  datoClass={inputClassesNOW + " w-80 h-100"}
                  objOpzioni={datiTendineOrdine.dhlCodPaese}
                  datoValue={
                    ordineTemp?.spedEclifor?.[0]?.["DHL_Cod_Paese"] ?? ""
                  }
                  bloccoClass={"w-50"}
                  permessoScrittura={
                    utente.permessiAPI["update:database"] ? "SI" : "NO"
                  }
                  labelOrizzontale="SI"
                />
                <div className="w-40 b">
                  {ordineTemp?.spedEclifor?.[0]?.["DHL_Cod_Paese"] ?? ""}
                </div>
              </div>
              <InputDatoProdotto
                inputLabel="Contenuto"
                datoName='spedEclifor[0]["DHL_Descr_cont"]'
                datoId="DHL_Descr_cont"
                datoValue={
                  ordineTemp?.spedEclifor?.[0]?.["DHL_Descr_cont"] ?? ""
                }
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-100"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
            </div>
          )}
          {ordineTemp?.spedEclifor?.[0]?.["Corriere"] === "UPS" && (
            <div className="flex flex-wrap justify-between items-center riqUPS">
              <div className="w-100 fw5 b mt3 mb1">UPS</div>
              <InputDatoProdotto
                inputLabel="Tipo servizio"
                datoName='spedEclifor[0]["UPS_Servizio"]'
                datoId="upsServizio"
                datoValue={ordineTemp?.spedEclifor?.[0]?.["UPS_Servizio"] ?? ""}
                datoPlaceHolder=""
                datoOnChange={handleChange}
                inputClass={inputClassesNOW + " w-80 h-100"}
                datoClass={"w-45"}
                labelClass={"wpx-60"}
                classiTastoSblocco={classiTastoSblocco}
                tastoCopiaAspetto="NO"
                modCompatta="SI"
                permessoScrittura={
                  utente.permessiAPI["update:database"] ? "SI" : "NO"
                }
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  function riquadroGrane(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Grane</h3>
        <div className="pa4  items-center flex flex-wrap justify-between">
          {/* <InputDatoProdotto
                    inputLabel="Spese sped"
                    datoName='spedEclifor[0]["Spese_di_spedizione"]'
                    tipoInput="number"
                    datoId="Spese_di_spedizione"
                    datoValue={ordineTemp?.spedEclifor?.[0]?.["Spese_di_spedizione"] ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-45"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                /> */}
          <div className="b mb3 ttu">Corrieri</div>
          <InputDatoTendinaGenerico
            inputLabel="Tipo"
            datoName='spedEclifor[0]["tipoGranaCorriere"]'
            elencoDati={datiTendineOrdine.tipoGranaCorriere}
            datoId="tipoGranaCorriere"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["tipoGranaCorriere"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Data"
            tipoInput="date"
            datoName='spedEclifor[0]["dataGranaCorriere"]'
            datoId="dataGranaCorriere"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["dataGranaCorriere"] &&
              toDate(ordineTemp.spedEclifor[0]["dataGranaCorriere"])
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <div className="b mb3 mt3 ttu">Marketplace</div>
          <InputDatoTendinaGenerico
            inputLabel="Tipo"
            datoName='spedEclifor[0]["tipoGranaMarketplace"]'
            elencoDati={datiTendineOrdine.tipoGranaMarketplace}
            datoId="tipoGranaMarketplace"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["tipoGranaMarketplace"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
          <InputDatoProdotto
            inputLabel="Data"
            tipoInput="date"
            datoName='spedEclifor[0]["dataGranaMarketplace"]'
            datoId="dataGranaMarketplace"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["dataGranaMarketplace"] &&
              toDate(ordineTemp.spedEclifor[0]["dataGranaMarketplace"])
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 "}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              utente.permessiAPI["update:database"] ? "SI" : "NO"
            }
          />
        </div>
      </div>
    );
  }

  function riquadroStatoMag(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h3 className="tc">Stato magazzino</h3>
        <div className="pa4 items-center flex flex-wrap justify-between">
          <InputDatoProdotto
            inputLabel="Stato"
            datoName='spedEclifor[0]["statoMag"]'
            datoId="statoMag"
            datoValue={ordineTemp?.spedEclifor?.[0]?.["statoMag"] ?? ""}
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              "NO" /*utente.permessiAPI["update:database"] ? "SI" : "NO" disattivo temporaneamente*/
            }
          />
          <InputDatoProdotto
            inputLabel="Magazzino"
            datoName='spedEclifor[0]["magazzinoStatoMag"]'
            datoId="magazzinoStatoMag"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["magazzinoStatoMag"] ?? ""
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              "NO" /*utente.permessiAPI["update:database"] ? "SI" : "NO" disattivo temporaneamente*/
            }
          />
          <InputDatoProdotto
            inputLabel="Data"
            tipoInput="date"
            datoName='spedEclifor[0]["dataStatoMag"]'
            datoId="dataStatoMag"
            datoValue={
              ordineTemp?.spedEclifor?.[0]?.["dataStatoMag"] &&
              toDate(ordineTemp.spedEclifor[0]["dataStatoMag"])
            }
            datoPlaceHolder=""
            datoOnChange={handleChange}
            inputClass={inputClassesNOW + " w-80 h-100"}
            datoClass={"w-100"}
            labelClass={"wpx-60"}
            classiTastoSblocco={classiTastoSblocco}
            tastoCopiaAspetto="NO"
            modCompatta="SI"
            permessoScrittura={
              "NO" /*utente.permessiAPI["update:database"] ? "SI" : "NO" disattivo temporaneamente*/
            }
          />
        </div>
      </div>
    );
  }

  function riquadroSpedizioniCollegate(height) {
    const tabButtons = [
      {
        id: "correlate",
        label: "Stesso ordine PS",
        enabled: spedizioniCorrelate?.length > 0,
      },
      {
        id: "garanzie",
        label: "Garanzie",
        enabled: garanzieCorrelate?.length > 0,
      },
      {
        id: "cliente",
        label: "Ordini cliente",
        enabled: ordiniCliente?.length > 0,
      },
    ];

    const renderLista = (lista) => {
      if (loadingSpedCorrelate) {
        return <div className="tc gray">Caricamento…</div>;
      }
      if (!lista?.length) {
        return <div className="tc gray">Nessun risultato</div>;
      }
      if (tabSpedizioniCollegate === "garanzie") {
        const statoClass = (stato) => {
          if (!stato) return "";
          if (stato === "ACCETTATA") return "colSpedito";
          if (stato === "RICHIESTA CREATA") return "colEtichette";
          if (stato === "RIFIUTATA") return "colAnnullato";
          if (stato.includes("ATTESA")) return "colAttesa";
          return "";
        };
        return (
          <div className="flex flex-column">
            {lista.map((g) => (
              <div
                key={
                  g.id ||
                  g.idGaranzia ||
                  g.codGaranziaProduttore ||
                  Math.random()
                }
                className="sfondoBiancoTema br4 pa3 mb3 ba b--black-10"
              >
                <div className="w-100 tc">
                  <div className="f4 b">
                    {g.codGaranziaProduttore || "Garanzia"}
                  </div>
                </div>
                <div className="flex w-100 bb bordoColAlt mt2">
                  <div
                    className={
                      statoClass(g.statoGaranzia) + " w-100 tc bordoColAlt pa3"
                    }
                  >
                    STATO
                    <br />
                    <strong>{g.statoGaranzia || "N/D"}</strong>
                  </div>
                </div>
                <div className="flex w-100 bb bordoColAlt">
                  <div className="w-50 tc br bordoColAlt pa2">
                    DATA GARANZIA
                    <br />
                    <strong>
                      {g.dataRichiestaGaranzia
                        ? umanizzaDataSenzaOre(g.dataRichiestaGaranzia)
                        : "-"}
                    </strong>
                  </div>
                  <div className={"w-50 tc bordoColAlt pa2"}>
                    CODICE ARTICOLO
                    <br />
                    <strong>{g.codiceArticolo || "-"}</strong>
                  </div>
                </div>
                <div className="w-100 tc pa2">
                  PROBLEMA
                  <br />
                  <div className="mt1">{g.descDifetto || "-"}</div>
                </div>
                {g["ID Spedizione"] && (
                  <button
                    className={buttonClassesWhite + " mt2"}
                    onClick={(e) =>
                      impostaOrdineCollegato(e, g["ID Spedizione"])
                    }
                  >
                    Apri spedizione origine
                  </button>
                )}
              </div>
            ))}
          </div>
        );
      }
      return (
        <div className="flex flex-column">
          {lista.map((item) => {
            const idCard =
              item["ID Spedizione"] ||
              item.id ||
              item.idSpedOriginale ||
              item.idSpedAProduttore ||
              item.idSpedRestituzioneCliente;
            const onOpen = idCard
              ? (e) => impostaOrdineCollegato(e, idCard)
              : undefined;
            return (
              <RiquadrinoOrdine
                key={idCard || Math.random()}
                ordine={item}
                impostaOrdine={onOpen}
                mostraArticoli
                token={token}
              />
            );
          })}
        </div>
      );
    };

    let listaAttiva = [];
    if (tabSpedizioniCollegate === "correlate") {
      listaAttiva = spedizioniCorrelate;
    } else if (tabSpedizioniCollegate === "garanzie") {
      listaAttiva = garanzieCorrelate;
    } else {
      listaAttiva = ordiniCliente;
    }

    return (
      <div className={"h-" + height + " sezioneConScroll sfondoColChiaro br4"}>
        <h3 className="tc">Spedizioni collegate</h3>
        <div className="flex justify-center mb3">
          {tabButtons.map((btn) => (
            <button
              key={btn.id}
              onClick={() => btn.enabled && setTabSpedizioniCollegate(btn.id)}
              className={
                tabSpedizioniCollegate === btn.id && btn.enabled
                  ? buttonClassesGreen
                  : btn.enabled
                    ? buttonClassesWhite
                    : "bg-light-gray gray ba b--light-gray br2 pa2 mh1 cursor-not-allowed"
              }
              style={!btn.enabled ? { pointerEvents: "none" } : {}}
            >
              {btn.label}
            </button>
          ))}
        </div>
        <div className="pa3">{renderLista(listaAttiva)}</div>
      </div>
    );
  }

  function riquadroResiRimborsi(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h2 className="tc">Resi e rimborsi</h2>

        {/* INIZIO GROSSO CASINO DEI BOOLEAN */}
        {ordineTemp.spedEclifor[0]["Reso"] === 1 &&
          utente.permessiAPI["update:database"] && (
            <p
              className=" pa2 br3 flex items-center justify-center pointer colReso white fw5"
              onClick={(e) =>
                switchaBoolGenerico(
                  ordineTemp.spedEclifor[0]["Reso"],
                  "spedEclifor[0].Reso",
                )
              }
            >
              <span className="material-icons pr2">radio_button_checked</span>
              Reso
            </p>
          )}
        {ordineTemp.spedEclifor[0]["Reso"] === 0 &&
          utente.permessiAPI["update:database"] && (
            <p
              className=" pa2 flex items-center justify-center pointer"
              onClick={(e) =>
                switchaBoolGenerico(
                  ordineTemp.spedEclifor[0]["Reso"],
                  "spedEclifor[0].Reso",
                )
              }
            >
              <span className="material-icons scrittaColoreAltScuro pr2">
                radio_button_unchecked
              </span>
              Reso
            </p>
          )}
        {!utente.permessiAPI["update:database"] &&
          ordineTemp.spedEclifor[0]["Reso"] === 1 && (
            <p className=" pa2 br3 flex items-center justify-center pointer colReso white fw5">
              <span className="material-icons pr2">radio_button_checked</span>
              Reso
            </p>
          )}
        {/* FINE GROSSO CASINO DEI BOOLEAN */}
        <div className="pa4">
          Importo totale ordine: €{" "}
          <strong>
            {ordineTemp?.spedEclifor?.[0]?.["Tot_imp_spedizione"] ?? ""}
          </strong>
          <br />
          Spese di spedizione: €{" "}
          <strong>
            {ordineTemp?.spedEclifor?.[0]?.["Spese_di_spedizione"] ?? ""}
          </strong>
          <br />
          Spese di contrassegno: €{" "}
          <strong>
            {ordineTemp?.spedEclifor?.[0]?.["Spese_di_contrassegno"] ?? ""}
          </strong>
          <br />
          {ordineTemp?.articoliArr?.length > 0 &&
            ordineTemp.articoliArr.map((art, i) => (
              <p className="">
                {"Articolo codice vs " + art["Cod Viglietti Sport"] + ": "}
                <strong>{"€" + art["Importo unitario"]}</strong>
                {" (" + art["Quantità"] + " pezzi, totale "}
                <strong>{art["Totale riga"]}</strong>
                {")"}
              </p>
            ))}
        </div>
        <div className="">
          {ordineTemp.resiErimborsiArr &&
            ordineTemp.resiErimborsiArr.map((res, i) => (
              <Reso
                utente={utente}
                reso={res}
                handleChangeImportoReso={handleChangeImportoReso}
                datiTendineOrdine={datiTendineOrdine}
                handleChange={handleChange}
                articoliSpedizione={ordineTemp.articoliArr}
                importoTotaleSpedizione={leggiNumero(
                  ordineTemp?.spedEclifor?.[0]?.["Tot_imp_spedizione"],
                )}
                importoSpedizione={leggiNumero(
                  ordineTemp?.spedEclifor?.[0]?.["Spese_di_spedizione"],
                )}
                importoContrassegno={leggiNumero(
                  ordineTemp?.spedEclifor?.[0]?.["Spese_di_contrassegno"],
                )}
                idSpedizione={ordineTemp?.spedEclifor?.[0]?.["ID Spedizione"]}
                applicaComposizioneRimborso={applicaComposizioneRimborso}
                i={i}
                key={
                  (ordineTemp?.spedEclifor?.[0]?.["ID Spedizione"] || "sped") +
                  "-" +
                  (res?.resiID || i)
                }
              />
            ))}

          {canUpdateLogistica && (
            <div className="tc mt4">
              <div
                className="ba material-icons pa2 br-100 bordoColAlt scrittaColAlt pointer"
                onClick={aggiungReso}
              >
                add
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function riquadroAttese(height) {
    const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(
      ordineTemp.spedEclifor[0]["userAttesa"],
      utente.username,
    );
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h2 className="tc">Gestione attesa</h2>
        {utente.permessiAPI["update:logistica"] &&
          ordineTemp?.spedEclifor?.[0]?.["userAttesa"] !== utente.username && (
            <div className="tc">
              <button
                className={buttonClassesWhite + " mb3"}
                onClick={ciPensoIo}
              >
                Ci penso io!
              </button>
            </div>
          )}
        {utente.permessiAPI["update:logistica"] &&
          ordineTemp?.spedEclifor?.[0]?.["userAttesa"] === utente.username && (
            <div className="tc">
              <button
                className={buttonClassesWhite + " mb3"}
                onClick={ciRipenso}
              >
                Ci ho ripensato
              </button>
            </div>
          )}
        {ordineTemp?.spedEclifor?.[0]?.["userAttesa"] && (
          <div className="flex items-center mb3">
            <div className="w-20">
              <img
                src={pathImmagine}
                className="br-100 dib"
                alt="foto utente"
              ></img>
            </div>
            <div className="w-80 pl3">
              Siamo in buone mani! Questo ordine è stato preso in gestione da{" "}
              <strong>{nomeDisplay}</strong>.
            </div>
          </div>
        )}
        <InputDatoTendinaGenerico
          inputLabel="Stato ordine"
          datoName='spedEclifor[0]["Stato_Ordine"]'
          elencoDati={datiTendineOrdine.statoOrdine}
          datoId="statoOrdine"
          datoValue={ordineTemp?.spedEclifor?.[0]?.["Stato_Ordine"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChangeStato}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <InputDatoTendinaGenerico
          inputLabel="Causa stato"
          datoName='spedEclifor[0]["Causale_Stato"]'
          elencoDati={datiTendineOrdine.causaleStato}
          datoId="causaleStato"
          datoValue={ordineTemp?.spedEclifor?.[0]?.["Causale_Stato"] ?? ""}
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        <InputDatoProdotto
          inputLabel="Data prom."
          tipoInput="date"
          datoName='spedEclifor[0]["dataPromemoria"]'
          datoId="dataProm"
          datoValue={
            ordineTemp?.spedEclifor?.[0]?.["dataPromemoria"] &&
            toDate(ordineTemp.spedEclifor[0]["dataPromemoria"])
          }
          datoPlaceHolder=""
          datoOnChange={handleChange}
          inputClass={inputClassesNOW + " w-80 h-100"}
          datoClass={"w-100"}
          labelClass={"wpx-60"}
          classiTastoSblocco={classiTastoSblocco}
          tastoCopiaAspetto="NO"
          modCompatta="SI"
          permessoScrittura={
            utente.permessiAPI["update:database"] ? "SI" : "NO"
          }
        />
        {/* tasto ricordamelo associato a dato spedizione */}
        {ordineTemp?.spedEclifor?.[0]?.["dataPromemoria"] &&
          utente.permessiAPI["update:database"] &&
          ordineTemp?.spedEclifor?.[0]?.["userAttesa"] === utente.username && (
            <div>
              {ordineTemp?.spedEclifor?.[0]?.["ricordamelo"] === 1 && (
                <p
                  className="br3 flex items-center pointer justify-center tastoVerde white pa2 fw5"
                  onClick={(e) =>
                    switchaBoolGenerico(
                      ordineTemp.spedEclifor[0]["ricordamelo"],
                      "spedEclifor[0].ricordamelo",
                    )
                  }
                >
                  <span className="material-icons pr2">alarm</span>Te lo
                  ricorderò
                </p>
              )}
              {ordineTemp?.spedEclifor?.[0]?.["ricordamelo"] === 0 && (
                <p
                  className="flex items-center justify-center pa2 pointer"
                  onClick={(e) =>
                    switchaBoolGenerico(
                      ordineTemp.spedEclifor[0]["ricordamelo"],
                      "spedEclifor[0].ricordamelo",
                    )
                  }
                >
                  <span className="material-icons scrittaColoreAltScuro pr2">
                    alarm
                  </span>
                  Ricordamelo
                </p>
              )}
            </div>
          )}
      </div>
    );
  }

  function riquadroTools(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <h2 className="tc">Strumenti</h2>
        <div className="pa4 tc">
          {/* NUOVO: Pulsante Split Ordine */}
          <button
            className={buttonClassesAttesa + " mb2"}
            onClick={() => setSplitModalOpen(!splitModalOpen)}
          >
            {splitModalOpen ? "Annulla Split" : "Splitta Ordine"}
          </button>
          {splitModalOpen && (
            <div className="tl ba pa3 br3 mt3 sfondoColAlt">
              <p className="fw5 mb2">Seleziona gli articoli da spostare:</p>
              {ordineTemp.articoliArr?.map((art) => (
                <div
                  key={art["ID Articolo"]}
                  className="flex items-center mb2 pointer"
                  onClick={() => toggleArticoloSplit(art["ID Articolo"])}
                >
                  <input
                    type="checkbox"
                    checked={articoliDaSplittare.includes(art["ID Articolo"])}
                    onChange={() => {}}
                    className="mr2"
                  />
                  <span>
                    {art["Cod Viglietti Sport"]} -{" "}
                    {art["Descrizione Articolo"]?.substring(0, 30)}...
                  </span>
                </div>
              ))}
              <button
                className={buttonClassesGreen + " mt3"}
                onClick={() => splittaOrdine()}
                disabled={splitInCorso || articoliDaSplittare.length === 0}
              >
                Conferma Split ({articoliDaSplittare.length} articoli)
              </button>
            </div>
          )}
          <br />
          <br />
          <button
            className={buttonClassesWhite + " mb2"}
            onClick={duplicaOrdine}
          >
            Nuova spedizione con gli stessi dati
          </button>
          <br />
          <br />
          <button
            className={buttonClassesWhite + " mb2"}
            onClick={duplicaOrdineConArticoli}
          >
            Nuova spedizione con gli stessi dati e gli stessi articoli
          </button>
          <br />
          <br />
          <button
            className={buttonClassesRed + " mb2"}
            onClick={cancellaSpedizione}
          >
            ELIMINA ORDINE
          </button>
          <br />
          <br />
          <button
            className={buttonClassesWhite + " mb2"}
            onClick={forzaCambioStato}
          >
            Forza cambio stato -TEST-
          </button>
          <br />
          <br />
          <button
            className={buttonClassesWhite + " mb2"}
            onClick={cancellaRifPS}
          >
            cancella rif ps
          </button>
        </div>
      </div>
    );
  }

  function riquadroObj(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <pre>{JSON.stringify(ordineTemp, null, 2)}</pre>
        {/* <pre>{JSON.stringify(ordineTemp, null, 2)}</pre> */}
      </div>
    );
  }

  function riquadroObjUtente(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <pre>{JSON.stringify(utente, null, 2)}</pre>
        {/* <pre>{JSON.stringify(ordineTemp, null, 2)}</pre> */}
      </div>
    );
  }

  function riquadroFeedback(height) {
    return (
      <div className={"h-" + height + "-ns sezioneConScroll"}>
        <pre>{JSON.stringify(resultSalvataggio, null, 2)}</pre>
      </div>
    );
  }

  function riquadroSceltaTab(height) {
    return (
      <div className="modificaOrdiniSideNavInner">
        <button
          type="button"
          className="modificaOrdiniSideNavToggle pointer"
          aria-label={menuOrdineEspanso ? "Comprimi menu" : "Espandi menu"}
          aria-expanded={menuOrdineEspanso}
          onClick={() => setMenuOrdineEspanso((aperto) => !aperto)}
        >
          <span className="material-icons scrittaColoreAltScuro">
            {menuOrdineEspanso ? "menu_open" : "menu"}
          </span>
          <span className="modificaOrdiniTabLabel ml2 dn db-ns">Menu</span>
        </button>
        <div className="modificaOrdiniSideNavItems">
          <div className="flex dn-ns dn-m w-100 justify-end">
            {/* parte dei tasti che si vede solo su mobile */}
            <TastoSelezionaTab
              idTasto="chiudi"
              onClickTasto={chiudiSenzaSalvare}
              tab={tab}
              vociMenuTabsSelezionata={vociMenuTabsSelezionata}
              vociMenuTabs={vociMenuTabs}
              icona="close"
              testo="Chiudi"
            />
            <TastoSelezionaTab
              idTasto="ordinePrincipale"
              onClickTasto={cambiaTab}
              tab={tab}
              vociMenuTabsSelezionata={vociMenuTabsSelezionata}
              vociMenuTabs={vociMenuTabs}
              icona="reorder"
              testo="Ordine"
            />
            <TastoSelezionaTab
              idTasto="statoOrdine"
              onClickTasto={cambiaTab}
              tab={tab}
              vociMenuTabsSelezionata={vociMenuTabsSelezionata}
              vociMenuTabs={vociMenuTabs}
              icona="grade"
              testo="Stato ordine"
            />
          </div>
          <TastoSelezionaTab
            idTasto="note"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="description"
            testo="Note"
          />
          <TastoSelezionaTab
            idTasto="articoli"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="shopping_cart"
            testo="Articoli"
          />
          <TastoSelezionaTab
            idTasto="carriers"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="local_shipping"
            testo="Corrieri"
          />
          <TastoSelezionaTab
            idTasto="grane"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="report_problem"
            testo="Grane"
          />
          <TastoSelezionaTab
            idTasto="spedizioniCollegate"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="link"
            testo="Spedizioni collegate"
          />
          {canReadLogistica && <TastoSelezionaTab
            idTasto="fatture"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="receipt_long"
            testo="Fatture"
          />}
          <TastoSelezionaTab
            idTasto="returnsRefunds"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="payments"
            testo="Resi e rimborsi"
          />
          {canUpdateLogistica && (
            <TastoSelezionaTab
              idTasto="tools"
              onClickTasto={cambiaTab}
              tab={tab}
              vociMenuTabsSelezionata={vociMenuTabsSelezionata}
              vociMenuTabs={vociMenuTabs}
              icona="handyman"
              testo="Tools"
            />
          )}
          <TastoSelezionaTab
            idTasto="attese"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="schedule"
            testo="Gestione attesa"
          />
          <TastoSelezionaTab
            idTasto="timeline"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="timeline"
            testo="Timeline"
          />
          <TastoSelezionaTab
            idTasto="statiPrestashop"
            onClickTasto={cambiaTab}
            tab={tab}
            vociMenuTabsSelezionata={vociMenuTabsSelezionata}
            vociMenuTabs={vociMenuTabs}
            icona="sync_alt"
            testo="Stati PS"
          />

          {utente.permessiAPI["read:debug"] && (
            <TastoSelezionaTab
              idTasto="debug"
              onClickTasto={cambiaTab}
              tab={tab}
              vociMenuTabsSelezionata={vociMenuTabsSelezionata}
              vociMenuTabs={vociMenuTabs}
              icona="bug_report"
              testo="Debug"
            />
          )}
        </div>
        <button
          ref={menuOrdinePinRef}
          type="button"
          className={
            "modificaOrdiniSideNavPin pointer pb3 " +
            (menuOrdineBloccato ? " modificaOrdiniSideNavPin--active" : "")
          }
          aria-label={menuOrdineBloccato ? "Sblocca menu" : "Blocca menu"}
          aria-pressed={menuOrdineBloccato}
          onClick={bloccaMenuOrdine}
        >
          {menuOrdineBloccato ? (
            <span className="material-symbols-outlined">keep_off</span>
          ) : (
            <span className="material-symbols-outlined">keep</span>
          )}
          <span className="modificaOrdiniTabLabel ml2 dn db-ns">blocca</span>
        </button>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////

  function colonnaServizio(
    widthCol1,
    tab1,
    hTab1,
    tab2,
    hTab2,
    widthCol2,
    col2tab1,
    hCol2Tab1,
    col2tab2,
    hCol2Tab2,
    widthCol3,
    col3tab1,
    hCol3Tab1,
    col3tab2,
    hCol3Tab2,
    widthCol4,
    col4tab1,
    hCol4Tab1,
    col4tab2,
    hCol4Tab2,
  ) {
    const renderServicePanel = (panel, height, extraClasses = "") => {
      if (!panel) {
        return null;
      }

      const heightClass = height ? " h-" + height + "-ns" : "";

      return (
        <div
          className={"modificaOrdiniServicePanel" + heightClass + extraClasses}
        >
          {panel(100)}
        </div>
      );
    };

    return (
      <div className="modificaOrdiniMainContent w-100 flex flex-wrap h-100">
        <div
          className={"w-100 w-" + widthCol1 + "-l pa3 bl-ns bordoColAlt h-100"}
        >
          <div className=" h-100">
            {renderServicePanel(tab1, hTab1)}
            {renderServicePanel(tab2, hTab2, " bt bordoColAlt dn db-ns")}
          </div>
        </div>
        <div
          className={
            "w-100 w-" + widthCol2 + "-l pa3 bl-ns dn db-ns bordoColAlt h-100"
          }
        >
          <div className=" h-100 ">
            {renderServicePanel(col2tab1, hCol2Tab1)}
            {renderServicePanel(col2tab2, hCol2Tab2, " bt bordoColAlt")}
          </div>
        </div>
        {widthCol3 && (
          <div
            className={
              "w-100 w-" + widthCol3 + "-l pa3 bl-ns dn db-ns bordoColAlt h-100"
            }
          >
            <div className=" h-100 ">
              {renderServicePanel(col3tab1, hCol3Tab1)}
              {renderServicePanel(col3tab2, hCol3Tab2, " bt bordoColAlt")}
            </div>
          </div>
        )}
        {widthCol4 && (
          <div
            className={
              "w-100 w-" + widthCol4 + "-l pa3 bl-ns dn db-ns bordoColAlt h-100"
            }
          >
            <div className=" h-100 ">
              {renderServicePanel(col4tab1, hCol4Tab1)}
              {renderServicePanel(col4tab2, hCol4Tab2, " bt bordoColAlt")}
            </div>
          </div>
        )}
      </div>
    );
  }

  ///// PAGINA

  return (
    <div className={classDivPrincipale}>
      <div className="modificaOrdiniShell ma3-ns br4-ns sfondoBiancoTema flex flex-wrap h-100 h-97-ns ">
        <div
          className={
            "modificaOrdiniSideNav" +
            (menuOrdineInHover ? " modificaOrdiniSideNav--hover" : "") +
            (menuOrdineEspanso ? " modificaOrdiniSideNav--open" : "") +
            (menuOrdineBloccato ? " modificaOrdiniSideNav--locked" : "")
          }
          onMouseMove={handleMenuOrdineMouseMove}
          onMouseLeave={() => setMenuOrdineInHover(false)}
        >
          {riquadroSceltaTab()}
        </div>
        <div className="modificaOrdiniSummary w-100 w-20-l flex flex-wrap h-100">
          <div className="w-100 dn db-ns pa2-ns pl3-ns pr3-ns pt4-ns pb4-ns datiOrdine">
            <div className="colonna85vh sezioneConScroll relative pl2">
              {riquadroSalvataggio()}
              {riquadroDatiOrdine()}
              {hasGaranzieCorrelate && (
                <div className={"mt4 br3 pa3 tc " + bannerGaranziaClass}>
                  <div className="f5 b flex items-center justify-center">
                    <span className="material-icons mr2">hardware</span>
                    GARANZIA: {statoGaranziaBanner || "N/D"}
                  </div>
                </div>
              )}
              {(utente.nomeDisplayAlt === "Mari" ||
                utente.nomeDisplayAlt === "Alessia" ||
                utente.nomeDisplayAlt === "Manu" ||
                utente.nomeDisplayAlt === "Ribes") && (
                <div className="flex justify-end items-end mt3 absolute bottom-0 right-0">
                  <img
                    alt="topo"
                    className="w-100 h-auto"
                    style={{ maxHeight: 70, objectFit: "contain" }}
                    src={mouseIMG}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* widthCol1, tab1, hTab1, tab2, hTab2, widthCol2, col2tab1, hCol2Tab1, col2tab2, hCol2Tab2 */}
        {tab === "default" &&
          colonnaServizio(
            25,
            riquadroStatoOrdine,
            35,
            riquadroNote,
            65,
            30,
            riquadroArticoli,
            100,
            false,
            false,
            20,
            riquadroDatiSpedizioneCliente,
            100,
            false,
            false,
            25,
            riquadroSpedizioniCollegate,
            mostraAtteseInHome ? 50 : 100,
            mostraAtteseInHome ? riquadroAttese : false,
            mostraAtteseInHome ? 100 : false,
          )}
        {tab === "ordinePrincipale" &&
          colonnaServizio(100, riquadroDatiOrdine, 100)}
        {tab === "statoOrdine" &&
          colonnaServizio(100, riquadroStatoOrdine, 100)}
        {tab === "articoli" &&
          colonnaServizio(
            40,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroDatiSpedizioneCliente,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "returnsRefunds" &&
          colonnaServizio(
            40,
            riquadroResiRimborsi,
            100,
            false,
            false,
            30,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroSpedizioniCollegate,
            100,
            false,
            false,
          )}
        {tab === "carriers" &&
          colonnaServizio(
            40,
            riquadroCorrieri,
            100,
            false,
            false,
            30,
            riquadroDatiSpedizioneCliente,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "grane" &&
          colonnaServizio(
            40,
            riquadroGrane,
            100,
            false,
            false,
            30,
            riquadroDatiSpedizioneCliente,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "statoMag" && colonnaServizio(100, riquadroStatoMag, 100)}
        {tab === "note" &&
          colonnaServizio(
            40,
            riquadroNote,
            100,
            false,
            false,
            30,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroSpedizioniCollegate,
            100,
            false,
            false,
          )}
        {tab === "attese" &&
          colonnaServizio(
            40,
            riquadroAttese,
            100,
            false,
            false,
            30,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "spedizioniCollegate" &&
          colonnaServizio(
            40,
            riquadroSpedizioniCollegate,
            100,
            false,
            false,
            30,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "tools" &&
          canUpdateLogistica &&
          colonnaServizio(
            40,
            riquadroTools,
            100,
            false,
            false,
            100,
            false,
            false,
          )}
        {tab === "attese" &&
          colonnaServizio(
            30,
            riquadroArticoli,
            100,
            false,
            false,
            30,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "debug" &&
          colonnaServizio(
            "third",
            riquadroObj,
            100,
            false,
            false,
            "third",
            riquadroObjUtente,
            100,
            false,
            false,
            "third",
            riquadroFeedback,
            100,
            false,
            false,
          )}
        {tab === "timeline" &&
          colonnaServizio(
            60,
            () => <Timeline idSped={ordine.spedEclifor[0]["ID Spedizione"]} />,
            100,
            false,
            false,
            40,
            riquadroNote,
            100,
            false,
            false,
          )}
        {tab === "fatture" && canReadLogistica && (
          <div className="modificaOrdiniMainContent w-100 h-100 pa3 bl-ns bordoColAlt">
            <Fatture idSped={idSpedizioneCorrente} utente={utente} />
          </div>
        )}
        {tab === "statiPrestashop" &&
          colonnaServizio(
            60,
            () => (
              <StatiPrestashop
                idSped={ordine.spedEclifor[0]["ID Spedizione"]}
              />
            ),
            100,
            false,
            false,
            40,
            riquadroNote,
            100,
            false,
            false,
          )}
      </div>
    </div>
  );
}

export default ModificaOrdini;
